// language=GraphQL
export const ALL_BOOKINGS_QUERY = `query Query($withTravel: Boolean = false, $withTravelAvailabilityStatus: Boolean = false, $withTravelAvailabilityStatusTenantSettings: Boolean = false, $withTravelTravelConsultant: Boolean = false, $withTravelTravelConsultantImage: Boolean = false, $withTravelLabel: Boolean = false, $withTravelSeoSettings: Boolean = false, $withTravelSeoSettingsOgImage: Boolean = false, $withTravelTenantSettings: Boolean = false, $withTravelTenantSettingsTenant: Boolean = false, $withTravelTenantSettingsTravelTypes: Boolean = false, $withTravelHighlights: Boolean = false, $withTravelPartners: Boolean = false, $withTravelPartnersLogo: Boolean = false, $withTravelPartnersGtcPdf: Boolean = false, $withTravelTravelGuides: Boolean = false, $withTravelTravelGuidesImage: Boolean = false, $withTravelTeams: Boolean = false, $withTravelTeamsMembers: Boolean = false, $withTravelAccommodationAssignments: Boolean = false, $withTravelAccommodationAssignmentsAccommodation: Boolean = false, $withTravelAccommodationAssignmentsRoomTypes: Boolean = false, $withTravelAccommodations: Boolean = false, $withTravelAccommodationsRoomTypes: Boolean = false, $withTravelAccommodationsAvailableAddons: Boolean = false, $withTravelAccommodationsGallery: Boolean = false, $withTravelDestinations: Boolean = false, $withTravelTestimonials: Boolean = false, $withTravelTestimonialsContentBlock: Boolean = false, $withTravelMainImage: Boolean = false, $withTravelMainVideo: Boolean = false, $withTravelGallery: Boolean = false, $withTravelGalleryImages: Boolean = false, $withTravelTravelPdf: Boolean = false, $withTravelTravelExtensions: Boolean = false, $withTravelTravelExtensionsHighlights: Boolean = false, $withTravelTravelExtensionsImage: Boolean = false, $withTravelItinerary: Boolean = false, $withTravelItineraryItems: Boolean = false, $withTravelPricing: Boolean = false, $withTravelPricingAgeGroupSettings: Boolean = false, $withTravelPricingCustomDataConfig: Boolean = false, $withTravelPricingTravels: Boolean = false, $withTravelPricingWebhookConfig: Boolean = false, $withTravelPricingBranding: Boolean = false, $withTravelPricingBargainSettings: Boolean = false, $withTravelPricingEsimSettings: Boolean = false, $withTravelPricingPassportConfig: Boolean = false, $withTravelPricingTourOperator: Boolean = false, $withPricingTravel: Boolean = false, $withPricingTravelRatioCatalogBundle: Boolean = false, $withPricingTravelDates: Boolean = false, $withPricingTravelDatesAvailabilityStatus: Boolean = false, $withPricingTravelDatesExtensionBaseDate: Boolean = false, $withPricingTravelDatesExtension: Boolean = false, $withPricingTravelDatesPackageSettings: Boolean = false, $withPricingTravelDatesExtensions: Boolean = false, $withPricingTravelAccommodations: Boolean = false, $withPricingTravelAccommodationsCapacitySettings: Boolean = false, $withPricingTravelAccommodationsAddons: Boolean = false, $withPricingTravelExtensionAccommodations: Boolean = false, $withPricingTravelFamilyPackages: Boolean = false, $withPricingTravelFamilyPackagesAccommodation: Boolean = false, $withPricingTravelFamilyPackagesCapacitySettings: Boolean = false, $withPricingTravelFamilyPackagesAddons: Boolean = false, $withPricingTravelPersonalAddons: Boolean = false, $withPricingTravelPersonalAddonsAllowedAgeGroups: Boolean = false, $withPricingTravelPersonalAddonsCalculationSettings: Boolean = false, $withPricingTravelPersonalAddonsMandatorySettings: Boolean = false, $withPricingTravelAccommodationAddons: Boolean = false, $withPricingTravelAccommodationAddonsCalculationSettings: Boolean = false, $withPricingTravelAccommodationAddonsMandatorySettings: Boolean = false, $withPricingTravelBookingAddons: Boolean = false, $withPricingTravelBookingAddonsCalculationSettings: Boolean = false, $withPricingTravelBookingAddonsMandatorySettings: Boolean = false, $withPricingTravelCollectiveAddons: Boolean = false, $withPricingTravelCollectiveAddonsAgeGroupServices: Boolean = false, $withPricingTravelCollectiveAddonsCalculationSettings: Boolean = false, $withPricingTravelCollectiveAddonsMandatorySettings: Boolean = false, $withPricingTravelExtensions: Boolean = false, $withPricingTravelExtensionsTravelExtension: Boolean = false, $withPricingTravelExtensionsAccommodationMapItems: Boolean = false, $withPricingTravelPersonalDiscounts: Boolean = false, $withPricingTravelPersonalDiscountsMandatorySettings: Boolean = false, $withTravelDate: Boolean = false, $withTravelDateAvailabilityStatus: Boolean = false, $withTravelDateAvailabilityStatusTenantSettings: Boolean = false, $withTravelDateExtensionBaseDate: Boolean = false, $withTravelDateExtensionBaseDateAvailabilityStatus: Boolean = false, $withTravelDateExtensionBaseDateExtensionBaseDate: Boolean = false, $withTravelDateExtensionBaseDateExtension: Boolean = false, $withTravelDateExtensionBaseDatePackageSettings: Boolean = false, $withTravelDateExtensionBaseDateExtensions: Boolean = false, $withTravelDateExtension: Boolean = false, $withTravelDateExtensionTravelExtension: Boolean = false, $withTravelDateExtensionAccommodationMapItems: Boolean = false, $withTravelDatePackageSettings: Boolean = false, $withTravelDateExtensions: Boolean = false, $withTravelDateExtensionsTravelExtension: Boolean = false, $withTravelDateExtensionsAccommodationMapItems: Boolean = false, $withTravellers: Boolean = false, $withTravellersAgeGroup: Boolean = false, $withTravellersAccommodation: Boolean = false, $withTravellersAccommodationCapacitySettings: Boolean = false, $withTravellersAccommodationAddons: Boolean = false, $withTravellersFamilyPackage: Boolean = false, $withTravellersFamilyPackageAccommodation: Boolean = false, $withTravellersFamilyPackageCapacitySettings: Boolean = false, $withTravellersFamilyPackageAddons: Boolean = false, $withTravellersAccommodationAddons: Boolean = false, $withTravellersAccommodationAddonsCalculationSettings: Boolean = false, $withTravellersAccommodationAddonsMandatorySettings: Boolean = false, $withTravellersPersonalAddons: Boolean = false, $withTravellersPersonalAddonsAllowedAgeGroups: Boolean = false, $withTravellersPersonalAddonsCalculationSettings: Boolean = false, $withTravellersPersonalAddonsMandatorySettings: Boolean = false, $withTravellersBookingAddons: Boolean = false, $withTravellersBookingAddonsCalculationSettings: Boolean = false, $withTravellersBookingAddonsMandatorySettings: Boolean = false, $withTravellersExtensions: Boolean = false, $withTravellersExtensionsTravelExtension: Boolean = false, $withTravellersExtensionsAccommodationMapItems: Boolean = false, $withTravellersPassportData: Boolean = false, $withOnlinePayments: Boolean = false, $withOnlinePaymentsTenant: Boolean = false, $withOnlinePaymentsTenantCms: Boolean = false, $withOnlinePaymentsTenantTravelTypes: Boolean = false, $withOnlinePaymentsTenantEmployees: Boolean = false, $withOnlinePaymentsTenantEmailConfig: Boolean = false, $withOnlinePaymentsTenantNewsletterProvider: Boolean = false, $withOnlinePaymentsTenantRedirects: Boolean = false, $withOnlinePaymentsTenantOnlinePaymentConfig: Boolean = false, $withOnlinePaymentsTenantRatioConfig: Boolean = false, $withOnlinePaymentsTenantContent: Boolean = false, $withOnlinePaymentsTenantPartnerTenants: Boolean = false, $withTenant: Boolean = false, $withTenantCms: Boolean = false, $withTenantCmsHomepage: Boolean = false, $withTenantCmsCategories: Boolean = false, $withTenantCmsPages: Boolean = false, $withTenantCmsErrorPage404: Boolean = false, $withTenantCmsErrorPage500: Boolean = false, $withTenantCmsConfig: Boolean = false, $withTenantTravelTypes: Boolean = false, $withTenantTravelTypesImage: Boolean = false, $withTenantEmployees: Boolean = false, $withTenantEmployeesImage: Boolean = false, $withTenantEmailConfig: Boolean = false, $withTenantNewsletterProvider: Boolean = false, $withTenantNewsletterProviderConfig: Boolean = false, $withTenantRedirects: Boolean = false, $withTenantRedirectsFromPage: Boolean = false, $withTenantRedirectsFromTravel: Boolean = false, $withTenantRedirectsToPage: Boolean = false, $withTenantRedirectsToTravel: Boolean = false, $withTenantOnlinePaymentConfig: Boolean = false, $withTenantRatioConfig: Boolean = false, $withTenantContent: Boolean = false, $withTenantPartnerTenants: Boolean = false, $withTenantPartnerTenantsTenant: Boolean = false) {
  bookings: bookings {
    id
    referenceNo
    travel @include(if: $withTravel) {
      id
      name
      isBestseller
      startDate
      endDate
      availabilityStatus @include(if: $withTravelAvailabilityStatus) {
        id
        label
        status
        isDefaultStatus
        isDefaultWaitlistFallback
        tenantSettings @include(if: $withTravelAvailabilityStatusTenantSettings) {
          id
          label
          info
          switchToStatusInfo
          submitButtonLabel
        }
      }
      executionStatus
      travelConsultant @include(if: $withTravelTravelConsultant) {
        id
        firstName
        lastName
        jobTitle
        description
        email
        image @include(if: $withTravelTravelConsultantImage) {
          id
          assetId
          publicId
          url
          resourceType
          format
          width
          height
          caption
          title
          description
        }
        phone
      }
      label @include(if: $withTravelLabel) {
        id
        label
      }
      title
      description
      includedServices
      excludedServices
      pricingTable
      priceCalculationInfo
      seoSettings @include(if: $withTravelSeoSettings) {
        id
        urlSlug
        metaTitle
        metaDescription
        ogTitle
        ogDescription
        ogImage @include(if: $withTravelSeoSettingsOgImage) {
          id
          assetId
          publicId
          url
          resourceType
          format
          width
          height
          caption
          title
          description
        }
      }
      tenantSettings @include(if: $withTravelTenantSettings) {
        id
        tenant @include(if: $withTravelTenantSettingsTenant) {
          id
          name
          slug
          domain
          externalReference
        }
        onlineStatus
        redirectToBooking
        useTiming
        startDate
        endDate
        travelTypes @include(if: $withTravelTenantSettingsTravelTypes) {
          id
          name
          description
        }
      }
      highlights @include(if: $withTravelHighlights) {
        id
        text
      }
      partners @include(if: $withTravelPartners) {
        id
        name
        url
        logo @include(if: $withTravelPartnersLogo) {
          id
          assetId
          publicId
          url
          resourceType
          format
          width
          height
          caption
          title
          description
        }
        logoWidth
        gtcPdf @include(if: $withTravelPartnersGtcPdf) {
          id
          assetId
          publicId
          url
          resourceType
          format
          width
          height
          caption
          title
          description
        }
      }
      travelGuides @include(if: $withTravelTravelGuides) {
        id
        firstName
        lastName
        description
        image @include(if: $withTravelTravelGuidesImage) {
          id
          assetId
          publicId
          url
          resourceType
          format
          width
          height
          caption
          title
          description
        }
      }
      teams @include(if: $withTravelTeams) {
        id
        name
        members @include(if: $withTravelTeamsMembers) {
          id
          firstName
          lastName
          description
        }
      }
      accommodationAssignments @include(if: $withTravelAccommodationAssignments) {
        id
        accommodation @include(if: $withTravelAccommodationAssignmentsAccommodation) {
          id
          label
          name
          stars
          description
        }
        roomTypes @include(if: $withTravelAccommodationAssignmentsRoomTypes) {
          id
          name
          description
        }
        useCustomRoomTypeSelection
      }
      accommodations @include(if: $withTravelAccommodations) {
        id
        label
        name
        stars
        description
        roomTypes @include(if: $withTravelAccommodationsRoomTypes) {
          id
          name
          description
        }
        availableAddons @include(if: $withTravelAccommodationsAvailableAddons) {
          id
          name
          description
        }
        gallery @include(if: $withTravelAccommodationsGallery) {
          id
        }
      }
      destinations @include(if: $withTravelDestinations) {
        id
        name
        entryRequirements
        medicalInformation
        language
        timeShift
        climate
        currency
      }
      testimonials @include(if: $withTravelTestimonials) {
        id
        contentBlock @include(if: $withTravelTestimonialsContentBlock) {
          id
          title
          text
          imagePosition
        }
      }
      mainImage @include(if: $withTravelMainImage) {
        id
        assetId
        publicId
        url
        resourceType
        format
        width
        height
        caption
        title
        description
      }
      mainVideo @include(if: $withTravelMainVideo) {
        id
        assetId
        publicId
        url
        resourceType
        format
        width
        height
        caption
        title
        description
      }
      gallery @include(if: $withTravelGallery) {
        id
        images @include(if: $withTravelGalleryImages) {
          id
          assetId
          publicId
          url
          resourceType
          format
          width
          height
          caption
          title
          description
        }
      }
      travelPdf @include(if: $withTravelTravelPdf) {
        id
        assetId
        publicId
        url
        resourceType
        format
        width
        height
        caption
        title
        description
      }
      travelExtensions @include(if: $withTravelTravelExtensions) {
        id
        duration
        name
        description
        highlights @include(if: $withTravelTravelExtensionsHighlights) {
          id
          text
        }
        image @include(if: $withTravelTravelExtensionsImage) {
          id
          assetId
          publicId
          url
          resourceType
          format
          width
          height
          caption
          title
          description
        }
      }
      programType
      itinerary @include(if: $withTravelItinerary) {
        id
        items @include(if: $withTravelItineraryItems) {
          id
          duration
          title
          text
        }
      }
      programText
      pricing @include(if: $withTravelPricing) {
        id
        ageGroupSettings @include(if: $withTravelPricingAgeGroupSettings) {
          id
          freeUntilAge
        }
        isTravelDocumentationAvailable
        customDataConfig @include(if: $withTravelPricingCustomDataConfig) {
          id
          useTravellerForm
          useBookingForm
        }
        travels @include(if: $withTravelPricingTravels) {
          id
          catalogCode
          travelCode
          destination
          name
          transportType
          transportTypeLabel
          importDateTime
          importStatus
        }
        webhookConfig @include(if: $withTravelPricingWebhookConfig) {
          id
          enabled
          url
        }
        branding @include(if: $withTravelPricingBranding) {
          id
          logoWidth
        }
        bargainSettings @include(if: $withTravelPricingBargainSettings) {
          id
          active
          untilDaysBeforeStart
        }
        esimSettings @include(if: $withTravelPricingEsimSettings) {
          id
          enabled
        }
        passportConfig @include(if: $withTravelPricingPassportConfig) {
          id
          passportOnly
        }
        tourOperator @include(if: $withTravelPricingTourOperator) {
          id
          name
          url
          logoWidth
        }
      }
      minPrice
      minPriceManualOverride
      currency
    }
    pricingTravel @include(if: $withPricingTravel) {
      id
      ratioCatalogBundle @include(if: $withPricingTravelRatioCatalogBundle) {
        id
        catalogCode
        travelCode
        json
      }
      catalogCode
      travelCode
      destination
      name
      transportType
      transportTypeLabel
      dates @include(if: $withPricingTravelDates) {
        id
        dateNo
        startDate
        endDate
        availabilityStatus @include(if: $withPricingTravelDatesAvailabilityStatus) {
          id
          label
          status
          isDefaultStatus
          isDefaultWaitlistFallback
        }
        includesExtension
        extensionBaseDate @include(if: $withPricingTravelDatesExtensionBaseDate) {
          id
          dateNo
          startDate
          endDate
          includesExtension
          json
        }
        extension @include(if: $withPricingTravelDatesExtension) {
          id
          label
          info
        }
        packageSettings @include(if: $withPricingTravelDatesPackageSettings) {
          id
          ratioPackageNo
          price
          availabilityStatus
        }
        json
        extensions @include(if: $withPricingTravelDatesExtensions) {
          id
          label
          info
        }
      }
      accommodations @include(if: $withPricingTravelAccommodations) {
        id
        ratioPackageNo
        name
        label
        info
        isFamilyPackageAccommodation
        isBabyPackage
        capacitySettings @include(if: $withPricingTravelAccommodationsCapacitySettings) {
          id
          totalCapacity
          rangesAllowed
          partialOccupancyAllowed
        }
        addons @include(if: $withPricingTravelAccommodationsAddons) {
          id
          ratioServiceNo
          name
          label
          info
        }
      }
      extensionAccommodations @include(if: $withPricingTravelExtensionAccommodations) {
        id
        ratioPackageNo
        name
        label
        info
        extensionAccommodationServiceNo
      }
      familyPackages @include(if: $withPricingTravelFamilyPackages) {
        id
        ratioServiceNo
        accommodation @include(if: $withPricingTravelFamilyPackagesAccommodation) {
          id
          ratioPackageNo
          name
          label
          info
          isFamilyPackageAccommodation
          isBabyPackage
        }
        name
        label
        info
        capacitySettings @include(if: $withPricingTravelFamilyPackagesCapacitySettings) {
          id
          totalCapacity
          rangesAllowed
          partialOccupancyAllowed
        }
        addons @include(if: $withPricingTravelFamilyPackagesAddons) {
          id
          ratioServiceNo
          name
          label
          info
        }
      }
      personalAddons @include(if: $withPricingTravelPersonalAddons) {
        id
        ratioServiceNo
        name
        label
        info
        allowedAgeGroups @include(if: $withPricingTravelPersonalAddonsAllowedAgeGroups) {
          id
          name
          type
          icon
          minAge
          maxAge
        }
        calculationSettings @include(if: $withPricingTravelPersonalAddonsCalculationSettings) {
          id
          type
          considerHotelNights
        }
        mandatorySettings @include(if: $withPricingTravelPersonalAddonsMandatorySettings) {
          id
          isMandatory
          useRules
        }
      }
      accommodationAddons @include(if: $withPricingTravelAccommodationAddons) {
        id
        ratioServiceNo
        name
        label
        info
        calculationSettings @include(if: $withPricingTravelAccommodationAddonsCalculationSettings) {
          id
          type
          considerHotelNights
        }
        mandatorySettings @include(if: $withPricingTravelAccommodationAddonsMandatorySettings) {
          id
          isMandatory
          useRules
        }
      }
      bookingAddons @include(if: $withPricingTravelBookingAddons) {
        id
        ratioServiceNo
        name
        label
        info
        calculationSettings @include(if: $withPricingTravelBookingAddonsCalculationSettings) {
          id
          type
          considerHotelNights
        }
        mandatorySettings @include(if: $withPricingTravelBookingAddonsMandatorySettings) {
          id
          isMandatory
          useRules
        }
      }
      collectiveAddons @include(if: $withPricingTravelCollectiveAddons) {
        id
        label
        info
        ageGroupServices @include(if: $withPricingTravelCollectiveAddonsAgeGroupServices) {
          id
          ratioServiceNo
        }
        calculationSettings @include(if: $withPricingTravelCollectiveAddonsCalculationSettings) {
          id
          type
          considerHotelNights
        }
        mandatorySettings @include(if: $withPricingTravelCollectiveAddonsMandatorySettings) {
          id
          isMandatory
          useRules
        }
      }
      extensions @include(if: $withPricingTravelExtensions) {
        id
        label
        info
        travelExtension @include(if: $withPricingTravelExtensionsTravelExtension) {
          id
          duration
          name
          description
        }
        accommodationMapItems @include(if: $withPricingTravelExtensionsAccommodationMapItems) {
          id
        }
      }
      personalDiscounts @include(if: $withPricingTravelPersonalDiscounts) {
        id
        ratioServiceNo
        name
        label
        info
        mandatorySettings @include(if: $withPricingTravelPersonalDiscountsMandatorySettings) {
          id
          isMandatory
          useRules
        }
      }
      importDateTime
      importStatus
    }
    travelDate @include(if: $withTravelDate) {
      id
      dateNo
      startDate
      endDate
      availabilityStatus @include(if: $withTravelDateAvailabilityStatus) {
        id
        label
        status
        isDefaultStatus
        isDefaultWaitlistFallback
        tenantSettings @include(if: $withTravelDateAvailabilityStatusTenantSettings) {
          id
          label
          info
          switchToStatusInfo
          submitButtonLabel
        }
      }
      includesExtension
      extensionBaseDate @include(if: $withTravelDateExtensionBaseDate) {
        id
        dateNo
        startDate
        endDate
        availabilityStatus @include(if: $withTravelDateExtensionBaseDateAvailabilityStatus) {
          id
          label
          status
          isDefaultStatus
          isDefaultWaitlistFallback
        }
        includesExtension
        extensionBaseDate @include(if: $withTravelDateExtensionBaseDateExtensionBaseDate) {
          id
          dateNo
          startDate
          endDate
          includesExtension
          json
        }
        extension @include(if: $withTravelDateExtensionBaseDateExtension) {
          id
          label
          info
        }
        packageSettings @include(if: $withTravelDateExtensionBaseDatePackageSettings) {
          id
          ratioPackageNo
          price
          availabilityStatus
        }
        json
        extensions @include(if: $withTravelDateExtensionBaseDateExtensions) {
          id
          label
          info
        }
      }
      extension @include(if: $withTravelDateExtension) {
        id
        label
        info
        travelExtension @include(if: $withTravelDateExtensionTravelExtension) {
          id
          duration
          name
          description
        }
        accommodationMapItems @include(if: $withTravelDateExtensionAccommodationMapItems) {
          id
        }
      }
      packageSettings @include(if: $withTravelDatePackageSettings) {
        id
        ratioPackageNo
        price
        availabilityStatus
      }
      json
      extensions @include(if: $withTravelDateExtensions) {
        id
        label
        info
        travelExtension @include(if: $withTravelDateExtensionsTravelExtension) {
          id
          duration
          name
          description
        }
        accommodationMapItems @include(if: $withTravelDateExtensionsAccommodationMapItems) {
          id
        }
      }
    }
    travellers @include(if: $withTravellers) {
      id
      salutation
      firstName
      lastName
      birthday
      nationality
      email
      phone
      address
      addressNumber
      addressAddition
      zip
      city
      country
      ageGroup @include(if: $withTravellersAgeGroup) {
        id
        name
        type
        icon
        minAge
        maxAge
      }
      accommodation @include(if: $withTravellersAccommodation) {
        id
        ratioPackageNo
        name
        label
        info
        isFamilyPackageAccommodation
        isBabyPackage
        capacitySettings @include(if: $withTravellersAccommodationCapacitySettings) {
          id
          totalCapacity
          rangesAllowed
          partialOccupancyAllowed
        }
        addons @include(if: $withTravellersAccommodationAddons) {
          id
          ratioServiceNo
          name
          label
          info
        }
      }
      familyPackage @include(if: $withTravellersFamilyPackage) {
        id
        ratioServiceNo
        accommodation @include(if: $withTravellersFamilyPackageAccommodation) {
          id
          ratioPackageNo
          name
          label
          info
          isFamilyPackageAccommodation
          isBabyPackage
        }
        name
        label
        info
        capacitySettings @include(if: $withTravellersFamilyPackageCapacitySettings) {
          id
          totalCapacity
          rangesAllowed
          partialOccupancyAllowed
        }
        addons @include(if: $withTravellersFamilyPackageAddons) {
          id
          ratioServiceNo
          name
          label
          info
        }
      }
      accommodationAddons @include(if: $withTravellersAccommodationAddons) {
        id
        ratioServiceNo
        name
        label
        info
        calculationSettings @include(if: $withTravellersAccommodationAddonsCalculationSettings) {
          id
          type
          considerHotelNights
        }
        mandatorySettings @include(if: $withTravellersAccommodationAddonsMandatorySettings) {
          id
          isMandatory
          useRules
        }
      }
      personalAddons @include(if: $withTravellersPersonalAddons) {
        id
        ratioServiceNo
        name
        label
        info
        allowedAgeGroups @include(if: $withTravellersPersonalAddonsAllowedAgeGroups) {
          id
          name
          type
          icon
          minAge
          maxAge
        }
        calculationSettings @include(if: $withTravellersPersonalAddonsCalculationSettings) {
          id
          type
          considerHotelNights
        }
        mandatorySettings @include(if: $withTravellersPersonalAddonsMandatorySettings) {
          id
          isMandatory
          useRules
        }
      }
      bookingAddons @include(if: $withTravellersBookingAddons) {
        id
        ratioServiceNo
        name
        label
        info
        calculationSettings @include(if: $withTravellersBookingAddonsCalculationSettings) {
          id
          type
          considerHotelNights
        }
        mandatorySettings @include(if: $withTravellersBookingAddonsMandatorySettings) {
          id
          isMandatory
          useRules
        }
      }
      extensions @include(if: $withTravellersExtensions) {
        id
        label
        info
        travelExtension @include(if: $withTravellersExtensionsTravelExtension) {
          id
          duration
          name
          description
        }
        accommodationMapItems @include(if: $withTravellersExtensionsAccommodationMapItems) {
          id
        }
      }
      passportData @include(if: $withTravellersPassportData) {
        id
        type
        number
        birthPlace
        issuePlace
        issueDate
        validUntil
      }
    }
    travellerRemarks
    travellerDataCorrectnessConfirmation
    localState
    backofficePayload
    backofficeResponse
    transmissionStatus
    webhookStatus
    webhookResponse
    webhookDuration
    onlinePayments @include(if: $withOnlinePayments) {
      id
      transactionId
      tenant @include(if: $withOnlinePaymentsTenant) {
        id
        name
        slug
        domain
        externalReference
        cms @include(if: $withOnlinePaymentsTenantCms) {
          id
        }
        travelTypes @include(if: $withOnlinePaymentsTenantTravelTypes) {
          id
          name
          description
        }
        employees @include(if: $withOnlinePaymentsTenantEmployees) {
          id
          firstName
          lastName
          jobTitle
          description
          email
          phone
        }
        emailConfig @include(if: $withOnlinePaymentsTenantEmailConfig) {
          id
          defaultInternalRecipientEmail
          internalBookingRecipientEmails
          bookingConfirmationTemplateId
          bookingConfirmationInternalTemplateId
          bookingRequestConfirmationTemplateId
          bookingWaitlistConfirmationTemplateId
          bookingWaitlistContingentCheckConfirmationTemplateId
          bookingCustomRequestTemplateId
          bookingPassportDataReminderTemplateId
          contactFormTemplateId
          esimInstallationInfoTemplateId
        }
        newsletterProvider @include(if: $withOnlinePaymentsTenantNewsletterProvider) {
          id
          provider
        }
        redirects @include(if: $withOnlinePaymentsTenantRedirects) {
          id
          fromType
          fromUrl
          toType
          toUrl
        }
        onlinePaymentConfig @include(if: $withOnlinePaymentsTenantOnlinePaymentConfig) {
          id
          enabled
          ratioFibuAccountNo
          infoText
          datatransThemeConfig
        }
        ratioConfig @include(if: $withOnlinePaymentsTenantRatioConfig) {
          id
          adressgruppe
        }
        content @include(if: $withOnlinePaymentsTenantContent) {
          id
          bookingInsuranceInfo
        }
        partnerTenants @include(if: $withOnlinePaymentsTenantPartnerTenants) {
          id
          filterCrossLinking
        }
      }
      transactionStatus
      submittedToBackoffice
      statusPayload
    }
    confirmationEmailSent
    tenant @include(if: $withTenant) {
      id
      name
      slug
      domain
      externalReference
      cms @include(if: $withTenantCms) {
        id
        homepage @include(if: $withTenantCmsHomepage) {
          id
          name
          onlineStatus
        }
        categories @include(if: $withTenantCmsCategories) {
          id
          name
        }
        pages @include(if: $withTenantCmsPages) {
          id
          name
          onlineStatus
        }
        errorPage404 @include(if: $withTenantCmsErrorPage404) {
          id
          name
          onlineStatus
        }
        errorPage500 @include(if: $withTenantCmsErrorPage500) {
          id
          name
          onlineStatus
        }
        config @include(if: $withTenantCmsConfig) {
          id
        }
      }
      travelTypes @include(if: $withTenantTravelTypes) {
        id
        name
        description
        image @include(if: $withTenantTravelTypesImage) {
          id
          assetId
          publicId
          url
          resourceType
          format
          width
          height
          caption
          title
          description
        }
      }
      employees @include(if: $withTenantEmployees) {
        id
        firstName
        lastName
        jobTitle
        description
        email
        image @include(if: $withTenantEmployeesImage) {
          id
          assetId
          publicId
          url
          resourceType
          format
          width
          height
          caption
          title
          description
        }
        phone
      }
      emailConfig @include(if: $withTenantEmailConfig) {
        id
        defaultInternalRecipientEmail
        internalBookingRecipientEmails
        bookingConfirmationTemplateId
        bookingConfirmationInternalTemplateId
        bookingRequestConfirmationTemplateId
        bookingWaitlistConfirmationTemplateId
        bookingWaitlistContingentCheckConfirmationTemplateId
        bookingCustomRequestTemplateId
        bookingPassportDataReminderTemplateId
        contactFormTemplateId
        esimInstallationInfoTemplateId
      }
      newsletterProvider @include(if: $withTenantNewsletterProvider) {
        id
        provider
        config @include(if: $withTenantNewsletterProviderConfig) {
          __typename
          ... on MailchimpConfig {
            id
            apiKey
            serverPrefix
            listId

          }
        }
      }
      redirects @include(if: $withTenantRedirects) {
        id
        fromType
        fromUrl
        fromPage @include(if: $withTenantRedirectsFromPage) {
          id
          name
          onlineStatus
        }
        fromTravel @include(if: $withTenantRedirectsFromTravel) {
          id
          name
          isBestseller
          startDate
          endDate
          executionStatus
          title
          description
          includedServices
          excludedServices
          pricingTable
          priceCalculationInfo
          programType
          programText
          minPrice
          minPriceManualOverride
          currency
        }
        toType
        toUrl
        toPage @include(if: $withTenantRedirectsToPage) {
          id
          name
          onlineStatus
        }
        toTravel @include(if: $withTenantRedirectsToTravel) {
          id
          name
          isBestseller
          startDate
          endDate
          executionStatus
          title
          description
          includedServices
          excludedServices
          pricingTable
          priceCalculationInfo
          programType
          programText
          minPrice
          minPriceManualOverride
          currency
        }
      }
      onlinePaymentConfig @include(if: $withTenantOnlinePaymentConfig) {
        id
        enabled
        ratioFibuAccountNo
        infoText
        datatransThemeConfig
      }
      ratioConfig @include(if: $withTenantRatioConfig) {
        id
        adressgruppe
      }
      content @include(if: $withTenantContent) {
        id
        bookingInsuranceInfo
      }
      partnerTenants @include(if: $withTenantPartnerTenants) {
        id
        tenant @include(if: $withTenantPartnerTenantsTenant) {
          id
          name
          slug
          domain
          externalReference
        }
        filterCrossLinking
      }
    }
    isPassportDataRequired
    passportDataReminderEmailSent
    passportDataReceived
  }
}`

// language=GraphQL
export const SINGLE_BOOKING_QUERY = `query Query($id: ID!, $withTravel: Boolean = false, $withTravelAvailabilityStatus: Boolean = false, $withTravelAvailabilityStatusTenantSettings: Boolean = false, $withTravelTravelConsultant: Boolean = false, $withTravelTravelConsultantImage: Boolean = false, $withTravelLabel: Boolean = false, $withTravelSeoSettings: Boolean = false, $withTravelSeoSettingsOgImage: Boolean = false, $withTravelTenantSettings: Boolean = false, $withTravelTenantSettingsTenant: Boolean = false, $withTravelTenantSettingsTravelTypes: Boolean = false, $withTravelHighlights: Boolean = false, $withTravelPartners: Boolean = false, $withTravelPartnersLogo: Boolean = false, $withTravelPartnersGtcPdf: Boolean = false, $withTravelTravelGuides: Boolean = false, $withTravelTravelGuidesImage: Boolean = false, $withTravelTeams: Boolean = false, $withTravelTeamsMembers: Boolean = false, $withTravelAccommodationAssignments: Boolean = false, $withTravelAccommodationAssignmentsAccommodation: Boolean = false, $withTravelAccommodationAssignmentsRoomTypes: Boolean = false, $withTravelAccommodations: Boolean = false, $withTravelAccommodationsRoomTypes: Boolean = false, $withTravelAccommodationsAvailableAddons: Boolean = false, $withTravelAccommodationsGallery: Boolean = false, $withTravelDestinations: Boolean = false, $withTravelTestimonials: Boolean = false, $withTravelTestimonialsContentBlock: Boolean = false, $withTravelMainImage: Boolean = false, $withTravelMainVideo: Boolean = false, $withTravelGallery: Boolean = false, $withTravelGalleryImages: Boolean = false, $withTravelTravelPdf: Boolean = false, $withTravelTravelExtensions: Boolean = false, $withTravelTravelExtensionsHighlights: Boolean = false, $withTravelTravelExtensionsImage: Boolean = false, $withTravelItinerary: Boolean = false, $withTravelItineraryItems: Boolean = false, $withTravelPricing: Boolean = false, $withTravelPricingAgeGroupSettings: Boolean = false, $withTravelPricingCustomDataConfig: Boolean = false, $withTravelPricingTravels: Boolean = false, $withTravelPricingWebhookConfig: Boolean = false, $withTravelPricingBranding: Boolean = false, $withTravelPricingBargainSettings: Boolean = false, $withTravelPricingEsimSettings: Boolean = false, $withTravelPricingPassportConfig: Boolean = false, $withTravelPricingTourOperator: Boolean = false, $withPricingTravel: Boolean = false, $withPricingTravelRatioCatalogBundle: Boolean = false, $withPricingTravelDates: Boolean = false, $withPricingTravelDatesAvailabilityStatus: Boolean = false, $withPricingTravelDatesExtensionBaseDate: Boolean = false, $withPricingTravelDatesExtension: Boolean = false, $withPricingTravelDatesPackageSettings: Boolean = false, $withPricingTravelDatesExtensions: Boolean = false, $withPricingTravelAccommodations: Boolean = false, $withPricingTravelAccommodationsCapacitySettings: Boolean = false, $withPricingTravelAccommodationsAddons: Boolean = false, $withPricingTravelExtensionAccommodations: Boolean = false, $withPricingTravelFamilyPackages: Boolean = false, $withPricingTravelFamilyPackagesAccommodation: Boolean = false, $withPricingTravelFamilyPackagesCapacitySettings: Boolean = false, $withPricingTravelFamilyPackagesAddons: Boolean = false, $withPricingTravelPersonalAddons: Boolean = false, $withPricingTravelPersonalAddonsAllowedAgeGroups: Boolean = false, $withPricingTravelPersonalAddonsCalculationSettings: Boolean = false, $withPricingTravelPersonalAddonsMandatorySettings: Boolean = false, $withPricingTravelAccommodationAddons: Boolean = false, $withPricingTravelAccommodationAddonsCalculationSettings: Boolean = false, $withPricingTravelAccommodationAddonsMandatorySettings: Boolean = false, $withPricingTravelBookingAddons: Boolean = false, $withPricingTravelBookingAddonsCalculationSettings: Boolean = false, $withPricingTravelBookingAddonsMandatorySettings: Boolean = false, $withPricingTravelCollectiveAddons: Boolean = false, $withPricingTravelCollectiveAddonsAgeGroupServices: Boolean = false, $withPricingTravelCollectiveAddonsCalculationSettings: Boolean = false, $withPricingTravelCollectiveAddonsMandatorySettings: Boolean = false, $withPricingTravelExtensions: Boolean = false, $withPricingTravelExtensionsTravelExtension: Boolean = false, $withPricingTravelExtensionsAccommodationMapItems: Boolean = false, $withPricingTravelPersonalDiscounts: Boolean = false, $withPricingTravelPersonalDiscountsMandatorySettings: Boolean = false, $withTravelDate: Boolean = false, $withTravelDateAvailabilityStatus: Boolean = false, $withTravelDateAvailabilityStatusTenantSettings: Boolean = false, $withTravelDateExtensionBaseDate: Boolean = false, $withTravelDateExtensionBaseDateAvailabilityStatus: Boolean = false, $withTravelDateExtensionBaseDateExtensionBaseDate: Boolean = false, $withTravelDateExtensionBaseDateExtension: Boolean = false, $withTravelDateExtensionBaseDatePackageSettings: Boolean = false, $withTravelDateExtensionBaseDateExtensions: Boolean = false, $withTravelDateExtension: Boolean = false, $withTravelDateExtensionTravelExtension: Boolean = false, $withTravelDateExtensionAccommodationMapItems: Boolean = false, $withTravelDatePackageSettings: Boolean = false, $withTravelDateExtensions: Boolean = false, $withTravelDateExtensionsTravelExtension: Boolean = false, $withTravelDateExtensionsAccommodationMapItems: Boolean = false, $withTravellers: Boolean = false, $withTravellersAgeGroup: Boolean = false, $withTravellersAccommodation: Boolean = false, $withTravellersAccommodationCapacitySettings: Boolean = false, $withTravellersAccommodationAddons: Boolean = false, $withTravellersFamilyPackage: Boolean = false, $withTravellersFamilyPackageAccommodation: Boolean = false, $withTravellersFamilyPackageCapacitySettings: Boolean = false, $withTravellersFamilyPackageAddons: Boolean = false, $withTravellersAccommodationAddons: Boolean = false, $withTravellersAccommodationAddonsCalculationSettings: Boolean = false, $withTravellersAccommodationAddonsMandatorySettings: Boolean = false, $withTravellersPersonalAddons: Boolean = false, $withTravellersPersonalAddonsAllowedAgeGroups: Boolean = false, $withTravellersPersonalAddonsCalculationSettings: Boolean = false, $withTravellersPersonalAddonsMandatorySettings: Boolean = false, $withTravellersBookingAddons: Boolean = false, $withTravellersBookingAddonsCalculationSettings: Boolean = false, $withTravellersBookingAddonsMandatorySettings: Boolean = false, $withTravellersExtensions: Boolean = false, $withTravellersExtensionsTravelExtension: Boolean = false, $withTravellersExtensionsAccommodationMapItems: Boolean = false, $withTravellersPassportData: Boolean = false, $withOnlinePayments: Boolean = false, $withOnlinePaymentsTenant: Boolean = false, $withOnlinePaymentsTenantCms: Boolean = false, $withOnlinePaymentsTenantTravelTypes: Boolean = false, $withOnlinePaymentsTenantEmployees: Boolean = false, $withOnlinePaymentsTenantEmailConfig: Boolean = false, $withOnlinePaymentsTenantNewsletterProvider: Boolean = false, $withOnlinePaymentsTenantRedirects: Boolean = false, $withOnlinePaymentsTenantOnlinePaymentConfig: Boolean = false, $withOnlinePaymentsTenantRatioConfig: Boolean = false, $withOnlinePaymentsTenantContent: Boolean = false, $withOnlinePaymentsTenantPartnerTenants: Boolean = false, $withTenant: Boolean = false, $withTenantCms: Boolean = false, $withTenantCmsHomepage: Boolean = false, $withTenantCmsCategories: Boolean = false, $withTenantCmsPages: Boolean = false, $withTenantCmsErrorPage404: Boolean = false, $withTenantCmsErrorPage500: Boolean = false, $withTenantCmsConfig: Boolean = false, $withTenantTravelTypes: Boolean = false, $withTenantTravelTypesImage: Boolean = false, $withTenantEmployees: Boolean = false, $withTenantEmployeesImage: Boolean = false, $withTenantEmailConfig: Boolean = false, $withTenantNewsletterProvider: Boolean = false, $withTenantNewsletterProviderConfig: Boolean = false, $withTenantRedirects: Boolean = false, $withTenantRedirectsFromPage: Boolean = false, $withTenantRedirectsFromTravel: Boolean = false, $withTenantRedirectsToPage: Boolean = false, $withTenantRedirectsToTravel: Boolean = false, $withTenantOnlinePaymentConfig: Boolean = false, $withTenantRatioConfig: Boolean = false, $withTenantContent: Boolean = false, $withTenantPartnerTenants: Boolean = false, $withTenantPartnerTenantsTenant: Boolean = false) {
  booking: booking(id: $id) {
    id
    referenceNo
    travel @include(if: $withTravel) {
      id
      name
      isBestseller
      startDate
      endDate
      availabilityStatus @include(if: $withTravelAvailabilityStatus) {
        id
        label
        status
        isDefaultStatus
        isDefaultWaitlistFallback
        tenantSettings @include(if: $withTravelAvailabilityStatusTenantSettings) {
          id
          label
          info
          switchToStatusInfo
          submitButtonLabel
        }
      }
      executionStatus
      travelConsultant @include(if: $withTravelTravelConsultant) {
        id
        firstName
        lastName
        jobTitle
        description
        email
        image @include(if: $withTravelTravelConsultantImage) {
          id
          assetId
          publicId
          url
          resourceType
          format
          width
          height
          caption
          title
          description
        }
        phone
      }
      label @include(if: $withTravelLabel) {
        id
        label
      }
      title
      description
      includedServices
      excludedServices
      pricingTable
      priceCalculationInfo
      seoSettings @include(if: $withTravelSeoSettings) {
        id
        urlSlug
        metaTitle
        metaDescription
        ogTitle
        ogDescription
        ogImage @include(if: $withTravelSeoSettingsOgImage) {
          id
          assetId
          publicId
          url
          resourceType
          format
          width
          height
          caption
          title
          description
        }
      }
      tenantSettings @include(if: $withTravelTenantSettings) {
        id
        tenant @include(if: $withTravelTenantSettingsTenant) {
          id
          name
          slug
          domain
          externalReference
        }
        onlineStatus
        redirectToBooking
        useTiming
        startDate
        endDate
        travelTypes @include(if: $withTravelTenantSettingsTravelTypes) {
          id
          name
          description
        }
      }
      highlights @include(if: $withTravelHighlights) {
        id
        text
      }
      partners @include(if: $withTravelPartners) {
        id
        name
        url
        logo @include(if: $withTravelPartnersLogo) {
          id
          assetId
          publicId
          url
          resourceType
          format
          width
          height
          caption
          title
          description
        }
        logoWidth
        gtcPdf @include(if: $withTravelPartnersGtcPdf) {
          id
          assetId
          publicId
          url
          resourceType
          format
          width
          height
          caption
          title
          description
        }
      }
      travelGuides @include(if: $withTravelTravelGuides) {
        id
        firstName
        lastName
        description
        image @include(if: $withTravelTravelGuidesImage) {
          id
          assetId
          publicId
          url
          resourceType
          format
          width
          height
          caption
          title
          description
        }
      }
      teams @include(if: $withTravelTeams) {
        id
        name
        members @include(if: $withTravelTeamsMembers) {
          id
          firstName
          lastName
          description
        }
      }
      accommodationAssignments @include(if: $withTravelAccommodationAssignments) {
        id
        accommodation @include(if: $withTravelAccommodationAssignmentsAccommodation) {
          id
          label
          name
          stars
          description
        }
        roomTypes @include(if: $withTravelAccommodationAssignmentsRoomTypes) {
          id
          name
          description
        }
        useCustomRoomTypeSelection
      }
      accommodations @include(if: $withTravelAccommodations) {
        id
        label
        name
        stars
        description
        roomTypes @include(if: $withTravelAccommodationsRoomTypes) {
          id
          name
          description
        }
        availableAddons @include(if: $withTravelAccommodationsAvailableAddons) {
          id
          name
          description
        }
        gallery @include(if: $withTravelAccommodationsGallery) {
          id
        }
      }
      destinations @include(if: $withTravelDestinations) {
        id
        name
        entryRequirements
        medicalInformation
        language
        timeShift
        climate
        currency
      }
      testimonials @include(if: $withTravelTestimonials) {
        id
        contentBlock @include(if: $withTravelTestimonialsContentBlock) {
          id
          title
          text
          imagePosition
        }
      }
      mainImage @include(if: $withTravelMainImage) {
        id
        assetId
        publicId
        url
        resourceType
        format
        width
        height
        caption
        title
        description
      }
      mainVideo @include(if: $withTravelMainVideo) {
        id
        assetId
        publicId
        url
        resourceType
        format
        width
        height
        caption
        title
        description
      }
      gallery @include(if: $withTravelGallery) {
        id
        images @include(if: $withTravelGalleryImages) {
          id
          assetId
          publicId
          url
          resourceType
          format
          width
          height
          caption
          title
          description
        }
      }
      travelPdf @include(if: $withTravelTravelPdf) {
        id
        assetId
        publicId
        url
        resourceType
        format
        width
        height
        caption
        title
        description
      }
      travelExtensions @include(if: $withTravelTravelExtensions) {
        id
        duration
        name
        description
        highlights @include(if: $withTravelTravelExtensionsHighlights) {
          id
          text
        }
        image @include(if: $withTravelTravelExtensionsImage) {
          id
          assetId
          publicId
          url
          resourceType
          format
          width
          height
          caption
          title
          description
        }
      }
      programType
      itinerary @include(if: $withTravelItinerary) {
        id
        items @include(if: $withTravelItineraryItems) {
          id
          duration
          title
          text
        }
      }
      programText
      pricing @include(if: $withTravelPricing) {
        id
        ageGroupSettings @include(if: $withTravelPricingAgeGroupSettings) {
          id
          freeUntilAge
        }
        isTravelDocumentationAvailable
        customDataConfig @include(if: $withTravelPricingCustomDataConfig) {
          id
          useTravellerForm
          useBookingForm
        }
        travels @include(if: $withTravelPricingTravels) {
          id
          catalogCode
          travelCode
          destination
          name
          transportType
          transportTypeLabel
          importDateTime
          importStatus
        }
        webhookConfig @include(if: $withTravelPricingWebhookConfig) {
          id
          enabled
          url
        }
        branding @include(if: $withTravelPricingBranding) {
          id
          logoWidth
        }
        bargainSettings @include(if: $withTravelPricingBargainSettings) {
          id
          active
          untilDaysBeforeStart
        }
        esimSettings @include(if: $withTravelPricingEsimSettings) {
          id
          enabled
        }
        passportConfig @include(if: $withTravelPricingPassportConfig) {
          id
          passportOnly
        }
        tourOperator @include(if: $withTravelPricingTourOperator) {
          id
          name
          url
          logoWidth
        }
      }
      minPrice
      minPriceManualOverride
      currency
    }
    pricingTravel @include(if: $withPricingTravel) {
      id
      ratioCatalogBundle @include(if: $withPricingTravelRatioCatalogBundle) {
        id
        catalogCode
        travelCode
        json
      }
      catalogCode
      travelCode
      destination
      name
      transportType
      transportTypeLabel
      dates @include(if: $withPricingTravelDates) {
        id
        dateNo
        startDate
        endDate
        availabilityStatus @include(if: $withPricingTravelDatesAvailabilityStatus) {
          id
          label
          status
          isDefaultStatus
          isDefaultWaitlistFallback
        }
        includesExtension
        extensionBaseDate @include(if: $withPricingTravelDatesExtensionBaseDate) {
          id
          dateNo
          startDate
          endDate
          includesExtension
          json
        }
        extension @include(if: $withPricingTravelDatesExtension) {
          id
          label
          info
        }
        packageSettings @include(if: $withPricingTravelDatesPackageSettings) {
          id
          ratioPackageNo
          price
          availabilityStatus
        }
        json
        extensions @include(if: $withPricingTravelDatesExtensions) {
          id
          label
          info
        }
      }
      accommodations @include(if: $withPricingTravelAccommodations) {
        id
        ratioPackageNo
        name
        label
        info
        isFamilyPackageAccommodation
        isBabyPackage
        capacitySettings @include(if: $withPricingTravelAccommodationsCapacitySettings) {
          id
          totalCapacity
          rangesAllowed
          partialOccupancyAllowed
        }
        addons @include(if: $withPricingTravelAccommodationsAddons) {
          id
          ratioServiceNo
          name
          label
          info
        }
      }
      extensionAccommodations @include(if: $withPricingTravelExtensionAccommodations) {
        id
        ratioPackageNo
        name
        label
        info
        extensionAccommodationServiceNo
      }
      familyPackages @include(if: $withPricingTravelFamilyPackages) {
        id
        ratioServiceNo
        accommodation @include(if: $withPricingTravelFamilyPackagesAccommodation) {
          id
          ratioPackageNo
          name
          label
          info
          isFamilyPackageAccommodation
          isBabyPackage
        }
        name
        label
        info
        capacitySettings @include(if: $withPricingTravelFamilyPackagesCapacitySettings) {
          id
          totalCapacity
          rangesAllowed
          partialOccupancyAllowed
        }
        addons @include(if: $withPricingTravelFamilyPackagesAddons) {
          id
          ratioServiceNo
          name
          label
          info
        }
      }
      personalAddons @include(if: $withPricingTravelPersonalAddons) {
        id
        ratioServiceNo
        name
        label
        info
        allowedAgeGroups @include(if: $withPricingTravelPersonalAddonsAllowedAgeGroups) {
          id
          name
          type
          icon
          minAge
          maxAge
        }
        calculationSettings @include(if: $withPricingTravelPersonalAddonsCalculationSettings) {
          id
          type
          considerHotelNights
        }
        mandatorySettings @include(if: $withPricingTravelPersonalAddonsMandatorySettings) {
          id
          isMandatory
          useRules
        }
      }
      accommodationAddons @include(if: $withPricingTravelAccommodationAddons) {
        id
        ratioServiceNo
        name
        label
        info
        calculationSettings @include(if: $withPricingTravelAccommodationAddonsCalculationSettings) {
          id
          type
          considerHotelNights
        }
        mandatorySettings @include(if: $withPricingTravelAccommodationAddonsMandatorySettings) {
          id
          isMandatory
          useRules
        }
      }
      bookingAddons @include(if: $withPricingTravelBookingAddons) {
        id
        ratioServiceNo
        name
        label
        info
        calculationSettings @include(if: $withPricingTravelBookingAddonsCalculationSettings) {
          id
          type
          considerHotelNights
        }
        mandatorySettings @include(if: $withPricingTravelBookingAddonsMandatorySettings) {
          id
          isMandatory
          useRules
        }
      }
      collectiveAddons @include(if: $withPricingTravelCollectiveAddons) {
        id
        label
        info
        ageGroupServices @include(if: $withPricingTravelCollectiveAddonsAgeGroupServices) {
          id
          ratioServiceNo
        }
        calculationSettings @include(if: $withPricingTravelCollectiveAddonsCalculationSettings) {
          id
          type
          considerHotelNights
        }
        mandatorySettings @include(if: $withPricingTravelCollectiveAddonsMandatorySettings) {
          id
          isMandatory
          useRules
        }
      }
      extensions @include(if: $withPricingTravelExtensions) {
        id
        label
        info
        travelExtension @include(if: $withPricingTravelExtensionsTravelExtension) {
          id
          duration
          name
          description
        }
        accommodationMapItems @include(if: $withPricingTravelExtensionsAccommodationMapItems) {
          id
        }
      }
      personalDiscounts @include(if: $withPricingTravelPersonalDiscounts) {
        id
        ratioServiceNo
        name
        label
        info
        mandatorySettings @include(if: $withPricingTravelPersonalDiscountsMandatorySettings) {
          id
          isMandatory
          useRules
        }
      }
      importDateTime
      importStatus
    }
    travelDate @include(if: $withTravelDate) {
      id
      dateNo
      startDate
      endDate
      availabilityStatus @include(if: $withTravelDateAvailabilityStatus) {
        id
        label
        status
        isDefaultStatus
        isDefaultWaitlistFallback
        tenantSettings @include(if: $withTravelDateAvailabilityStatusTenantSettings) {
          id
          label
          info
          switchToStatusInfo
          submitButtonLabel
        }
      }
      includesExtension
      extensionBaseDate @include(if: $withTravelDateExtensionBaseDate) {
        id
        dateNo
        startDate
        endDate
        availabilityStatus @include(if: $withTravelDateExtensionBaseDateAvailabilityStatus) {
          id
          label
          status
          isDefaultStatus
          isDefaultWaitlistFallback
        }
        includesExtension
        extensionBaseDate @include(if: $withTravelDateExtensionBaseDateExtensionBaseDate) {
          id
          dateNo
          startDate
          endDate
          includesExtension
          json
        }
        extension @include(if: $withTravelDateExtensionBaseDateExtension) {
          id
          label
          info
        }
        packageSettings @include(if: $withTravelDateExtensionBaseDatePackageSettings) {
          id
          ratioPackageNo
          price
          availabilityStatus
        }
        json
        extensions @include(if: $withTravelDateExtensionBaseDateExtensions) {
          id
          label
          info
        }
      }
      extension @include(if: $withTravelDateExtension) {
        id
        label
        info
        travelExtension @include(if: $withTravelDateExtensionTravelExtension) {
          id
          duration
          name
          description
        }
        accommodationMapItems @include(if: $withTravelDateExtensionAccommodationMapItems) {
          id
        }
      }
      packageSettings @include(if: $withTravelDatePackageSettings) {
        id
        ratioPackageNo
        price
        availabilityStatus
      }
      json
      extensions @include(if: $withTravelDateExtensions) {
        id
        label
        info
        travelExtension @include(if: $withTravelDateExtensionsTravelExtension) {
          id
          duration
          name
          description
        }
        accommodationMapItems @include(if: $withTravelDateExtensionsAccommodationMapItems) {
          id
        }
      }
    }
    travellers @include(if: $withTravellers) {
      id
      salutation
      firstName
      lastName
      birthday
      nationality
      email
      phone
      address
      addressNumber
      addressAddition
      zip
      city
      country
      ageGroup @include(if: $withTravellersAgeGroup) {
        id
        name
        type
        icon
        minAge
        maxAge
      }
      accommodation @include(if: $withTravellersAccommodation) {
        id
        ratioPackageNo
        name
        label
        info
        isFamilyPackageAccommodation
        isBabyPackage
        capacitySettings @include(if: $withTravellersAccommodationCapacitySettings) {
          id
          totalCapacity
          rangesAllowed
          partialOccupancyAllowed
        }
        addons @include(if: $withTravellersAccommodationAddons) {
          id
          ratioServiceNo
          name
          label
          info
        }
      }
      familyPackage @include(if: $withTravellersFamilyPackage) {
        id
        ratioServiceNo
        accommodation @include(if: $withTravellersFamilyPackageAccommodation) {
          id
          ratioPackageNo
          name
          label
          info
          isFamilyPackageAccommodation
          isBabyPackage
        }
        name
        label
        info
        capacitySettings @include(if: $withTravellersFamilyPackageCapacitySettings) {
          id
          totalCapacity
          rangesAllowed
          partialOccupancyAllowed
        }
        addons @include(if: $withTravellersFamilyPackageAddons) {
          id
          ratioServiceNo
          name
          label
          info
        }
      }
      accommodationAddons @include(if: $withTravellersAccommodationAddons) {
        id
        ratioServiceNo
        name
        label
        info
        calculationSettings @include(if: $withTravellersAccommodationAddonsCalculationSettings) {
          id
          type
          considerHotelNights
        }
        mandatorySettings @include(if: $withTravellersAccommodationAddonsMandatorySettings) {
          id
          isMandatory
          useRules
        }
      }
      personalAddons @include(if: $withTravellersPersonalAddons) {
        id
        ratioServiceNo
        name
        label
        info
        allowedAgeGroups @include(if: $withTravellersPersonalAddonsAllowedAgeGroups) {
          id
          name
          type
          icon
          minAge
          maxAge
        }
        calculationSettings @include(if: $withTravellersPersonalAddonsCalculationSettings) {
          id
          type
          considerHotelNights
        }
        mandatorySettings @include(if: $withTravellersPersonalAddonsMandatorySettings) {
          id
          isMandatory
          useRules
        }
      }
      bookingAddons @include(if: $withTravellersBookingAddons) {
        id
        ratioServiceNo
        name
        label
        info
        calculationSettings @include(if: $withTravellersBookingAddonsCalculationSettings) {
          id
          type
          considerHotelNights
        }
        mandatorySettings @include(if: $withTravellersBookingAddonsMandatorySettings) {
          id
          isMandatory
          useRules
        }
      }
      extensions @include(if: $withTravellersExtensions) {
        id
        label
        info
        travelExtension @include(if: $withTravellersExtensionsTravelExtension) {
          id
          duration
          name
          description
        }
        accommodationMapItems @include(if: $withTravellersExtensionsAccommodationMapItems) {
          id
        }
      }
      passportData @include(if: $withTravellersPassportData) {
        id
        type
        number
        birthPlace
        issuePlace
        issueDate
        validUntil
      }
    }
    travellerRemarks
    travellerDataCorrectnessConfirmation
    localState
    backofficePayload
    backofficeResponse
    transmissionStatus
    webhookStatus
    webhookResponse
    webhookDuration
    onlinePayments @include(if: $withOnlinePayments) {
      id
      transactionId
      tenant @include(if: $withOnlinePaymentsTenant) {
        id
        name
        slug
        domain
        externalReference
        cms @include(if: $withOnlinePaymentsTenantCms) {
          id
        }
        travelTypes @include(if: $withOnlinePaymentsTenantTravelTypes) {
          id
          name
          description
        }
        employees @include(if: $withOnlinePaymentsTenantEmployees) {
          id
          firstName
          lastName
          jobTitle
          description
          email
          phone
        }
        emailConfig @include(if: $withOnlinePaymentsTenantEmailConfig) {
          id
          defaultInternalRecipientEmail
          internalBookingRecipientEmails
          bookingConfirmationTemplateId
          bookingConfirmationInternalTemplateId
          bookingRequestConfirmationTemplateId
          bookingWaitlistConfirmationTemplateId
          bookingWaitlistContingentCheckConfirmationTemplateId
          bookingCustomRequestTemplateId
          bookingPassportDataReminderTemplateId
          contactFormTemplateId
          esimInstallationInfoTemplateId
        }
        newsletterProvider @include(if: $withOnlinePaymentsTenantNewsletterProvider) {
          id
          provider
        }
        redirects @include(if: $withOnlinePaymentsTenantRedirects) {
          id
          fromType
          fromUrl
          toType
          toUrl
        }
        onlinePaymentConfig @include(if: $withOnlinePaymentsTenantOnlinePaymentConfig) {
          id
          enabled
          ratioFibuAccountNo
          infoText
          datatransThemeConfig
        }
        ratioConfig @include(if: $withOnlinePaymentsTenantRatioConfig) {
          id
          adressgruppe
        }
        content @include(if: $withOnlinePaymentsTenantContent) {
          id
          bookingInsuranceInfo
        }
        partnerTenants @include(if: $withOnlinePaymentsTenantPartnerTenants) {
          id
          filterCrossLinking
        }
      }
      transactionStatus
      submittedToBackoffice
      statusPayload
    }
    confirmationEmailSent
    tenant @include(if: $withTenant) {
      id
      name
      slug
      domain
      externalReference
      cms @include(if: $withTenantCms) {
        id
        homepage @include(if: $withTenantCmsHomepage) {
          id
          name
          onlineStatus
        }
        categories @include(if: $withTenantCmsCategories) {
          id
          name
        }
        pages @include(if: $withTenantCmsPages) {
          id
          name
          onlineStatus
        }
        errorPage404 @include(if: $withTenantCmsErrorPage404) {
          id
          name
          onlineStatus
        }
        errorPage500 @include(if: $withTenantCmsErrorPage500) {
          id
          name
          onlineStatus
        }
        config @include(if: $withTenantCmsConfig) {
          id
        }
      }
      travelTypes @include(if: $withTenantTravelTypes) {
        id
        name
        description
        image @include(if: $withTenantTravelTypesImage) {
          id
          assetId
          publicId
          url
          resourceType
          format
          width
          height
          caption
          title
          description
        }
      }
      employees @include(if: $withTenantEmployees) {
        id
        firstName
        lastName
        jobTitle
        description
        email
        image @include(if: $withTenantEmployeesImage) {
          id
          assetId
          publicId
          url
          resourceType
          format
          width
          height
          caption
          title
          description
        }
        phone
      }
      emailConfig @include(if: $withTenantEmailConfig) {
        id
        defaultInternalRecipientEmail
        internalBookingRecipientEmails
        bookingConfirmationTemplateId
        bookingConfirmationInternalTemplateId
        bookingRequestConfirmationTemplateId
        bookingWaitlistConfirmationTemplateId
        bookingWaitlistContingentCheckConfirmationTemplateId
        bookingCustomRequestTemplateId
        bookingPassportDataReminderTemplateId
        contactFormTemplateId
        esimInstallationInfoTemplateId
      }
      newsletterProvider @include(if: $withTenantNewsletterProvider) {
        id
        provider
        config @include(if: $withTenantNewsletterProviderConfig) {
          __typename
          ... on MailchimpConfig {
            id
            apiKey
            serverPrefix
            listId

          }
        }
      }
      redirects @include(if: $withTenantRedirects) {
        id
        fromType
        fromUrl
        fromPage @include(if: $withTenantRedirectsFromPage) {
          id
          name
          onlineStatus
        }
        fromTravel @include(if: $withTenantRedirectsFromTravel) {
          id
          name
          isBestseller
          startDate
          endDate
          executionStatus
          title
          description
          includedServices
          excludedServices
          pricingTable
          priceCalculationInfo
          programType
          programText
          minPrice
          minPriceManualOverride
          currency
        }
        toType
        toUrl
        toPage @include(if: $withTenantRedirectsToPage) {
          id
          name
          onlineStatus
        }
        toTravel @include(if: $withTenantRedirectsToTravel) {
          id
          name
          isBestseller
          startDate
          endDate
          executionStatus
          title
          description
          includedServices
          excludedServices
          pricingTable
          priceCalculationInfo
          programType
          programText
          minPrice
          minPriceManualOverride
          currency
        }
      }
      onlinePaymentConfig @include(if: $withTenantOnlinePaymentConfig) {
        id
        enabled
        ratioFibuAccountNo
        infoText
        datatransThemeConfig
      }
      ratioConfig @include(if: $withTenantRatioConfig) {
        id
        adressgruppe
      }
      content @include(if: $withTenantContent) {
        id
        bookingInsuranceInfo
      }
      partnerTenants @include(if: $withTenantPartnerTenants) {
        id
        tenant @include(if: $withTenantPartnerTenantsTenant) {
          id
          name
          slug
          domain
          externalReference
        }
        filterCrossLinking
      }
    }
    isPassportDataRequired
    passportDataReminderEmailSent
    passportDataReceived
  }
}`

// language=GraphQL
export const CREATE_BOOKING_MUTATION = `
  mutation Mutation($input: CreateBookingInput, $withTravel: Boolean = false, $withTravelAvailabilityStatus: Boolean = false, $withTravelAvailabilityStatusTenantSettings: Boolean = false, $withTravelTravelConsultant: Boolean = false, $withTravelTravelConsultantImage: Boolean = false, $withTravelLabel: Boolean = false, $withTravelSeoSettings: Boolean = false, $withTravelSeoSettingsOgImage: Boolean = false, $withTravelTenantSettings: Boolean = false, $withTravelTenantSettingsTenant: Boolean = false, $withTravelTenantSettingsTravelTypes: Boolean = false, $withTravelHighlights: Boolean = false, $withTravelPartners: Boolean = false, $withTravelPartnersLogo: Boolean = false, $withTravelPartnersGtcPdf: Boolean = false, $withTravelTravelGuides: Boolean = false, $withTravelTravelGuidesImage: Boolean = false, $withTravelTeams: Boolean = false, $withTravelTeamsMembers: Boolean = false, $withTravelAccommodationAssignments: Boolean = false, $withTravelAccommodationAssignmentsAccommodation: Boolean = false, $withTravelAccommodationAssignmentsRoomTypes: Boolean = false, $withTravelAccommodations: Boolean = false, $withTravelAccommodationsRoomTypes: Boolean = false, $withTravelAccommodationsAvailableAddons: Boolean = false, $withTravelAccommodationsGallery: Boolean = false, $withTravelDestinations: Boolean = false, $withTravelTestimonials: Boolean = false, $withTravelTestimonialsContentBlock: Boolean = false, $withTravelMainImage: Boolean = false, $withTravelMainVideo: Boolean = false, $withTravelGallery: Boolean = false, $withTravelGalleryImages: Boolean = false, $withTravelTravelPdf: Boolean = false, $withTravelTravelExtensions: Boolean = false, $withTravelTravelExtensionsHighlights: Boolean = false, $withTravelTravelExtensionsImage: Boolean = false, $withTravelItinerary: Boolean = false, $withTravelItineraryItems: Boolean = false, $withTravelPricing: Boolean = false, $withTravelPricingAgeGroupSettings: Boolean = false, $withTravelPricingCustomDataConfig: Boolean = false, $withTravelPricingTravels: Boolean = false, $withTravelPricingWebhookConfig: Boolean = false, $withTravelPricingBranding: Boolean = false, $withTravelPricingBargainSettings: Boolean = false, $withTravelPricingEsimSettings: Boolean = false, $withTravelPricingPassportConfig: Boolean = false, $withTravelPricingTourOperator: Boolean = false, $withPricingTravel: Boolean = false, $withPricingTravelRatioCatalogBundle: Boolean = false, $withPricingTravelDates: Boolean = false, $withPricingTravelDatesAvailabilityStatus: Boolean = false, $withPricingTravelDatesExtensionBaseDate: Boolean = false, $withPricingTravelDatesExtension: Boolean = false, $withPricingTravelDatesPackageSettings: Boolean = false, $withPricingTravelDatesExtensions: Boolean = false, $withPricingTravelAccommodations: Boolean = false, $withPricingTravelAccommodationsCapacitySettings: Boolean = false, $withPricingTravelAccommodationsAddons: Boolean = false, $withPricingTravelExtensionAccommodations: Boolean = false, $withPricingTravelFamilyPackages: Boolean = false, $withPricingTravelFamilyPackagesAccommodation: Boolean = false, $withPricingTravelFamilyPackagesCapacitySettings: Boolean = false, $withPricingTravelFamilyPackagesAddons: Boolean = false, $withPricingTravelPersonalAddons: Boolean = false, $withPricingTravelPersonalAddonsAllowedAgeGroups: Boolean = false, $withPricingTravelPersonalAddonsCalculationSettings: Boolean = false, $withPricingTravelPersonalAddonsMandatorySettings: Boolean = false, $withPricingTravelAccommodationAddons: Boolean = false, $withPricingTravelAccommodationAddonsCalculationSettings: Boolean = false, $withPricingTravelAccommodationAddonsMandatorySettings: Boolean = false, $withPricingTravelBookingAddons: Boolean = false, $withPricingTravelBookingAddonsCalculationSettings: Boolean = false, $withPricingTravelBookingAddonsMandatorySettings: Boolean = false, $withPricingTravelCollectiveAddons: Boolean = false, $withPricingTravelCollectiveAddonsAgeGroupServices: Boolean = false, $withPricingTravelCollectiveAddonsCalculationSettings: Boolean = false, $withPricingTravelCollectiveAddonsMandatorySettings: Boolean = false, $withPricingTravelExtensions: Boolean = false, $withPricingTravelExtensionsTravelExtension: Boolean = false, $withPricingTravelExtensionsAccommodationMapItems: Boolean = false, $withPricingTravelPersonalDiscounts: Boolean = false, $withPricingTravelPersonalDiscountsMandatorySettings: Boolean = false, $withTravelDate: Boolean = false, $withTravelDateAvailabilityStatus: Boolean = false, $withTravelDateAvailabilityStatusTenantSettings: Boolean = false, $withTravelDateExtensionBaseDate: Boolean = false, $withTravelDateExtensionBaseDateAvailabilityStatus: Boolean = false, $withTravelDateExtensionBaseDateExtensionBaseDate: Boolean = false, $withTravelDateExtensionBaseDateExtension: Boolean = false, $withTravelDateExtensionBaseDatePackageSettings: Boolean = false, $withTravelDateExtensionBaseDateExtensions: Boolean = false, $withTravelDateExtension: Boolean = false, $withTravelDateExtensionTravelExtension: Boolean = false, $withTravelDateExtensionAccommodationMapItems: Boolean = false, $withTravelDatePackageSettings: Boolean = false, $withTravelDateExtensions: Boolean = false, $withTravelDateExtensionsTravelExtension: Boolean = false, $withTravelDateExtensionsAccommodationMapItems: Boolean = false, $withTravellers: Boolean = false, $withTravellersAgeGroup: Boolean = false, $withTravellersAccommodation: Boolean = false, $withTravellersAccommodationCapacitySettings: Boolean = false, $withTravellersAccommodationAddons: Boolean = false, $withTravellersFamilyPackage: Boolean = false, $withTravellersFamilyPackageAccommodation: Boolean = false, $withTravellersFamilyPackageCapacitySettings: Boolean = false, $withTravellersFamilyPackageAddons: Boolean = false, $withTravellersAccommodationAddons: Boolean = false, $withTravellersAccommodationAddonsCalculationSettings: Boolean = false, $withTravellersAccommodationAddonsMandatorySettings: Boolean = false, $withTravellersPersonalAddons: Boolean = false, $withTravellersPersonalAddonsAllowedAgeGroups: Boolean = false, $withTravellersPersonalAddonsCalculationSettings: Boolean = false, $withTravellersPersonalAddonsMandatorySettings: Boolean = false, $withTravellersBookingAddons: Boolean = false, $withTravellersBookingAddonsCalculationSettings: Boolean = false, $withTravellersBookingAddonsMandatorySettings: Boolean = false, $withTravellersExtensions: Boolean = false, $withTravellersExtensionsTravelExtension: Boolean = false, $withTravellersExtensionsAccommodationMapItems: Boolean = false, $withTravellersPassportData: Boolean = false, $withOnlinePayments: Boolean = false, $withOnlinePaymentsTenant: Boolean = false, $withOnlinePaymentsTenantCms: Boolean = false, $withOnlinePaymentsTenantTravelTypes: Boolean = false, $withOnlinePaymentsTenantEmployees: Boolean = false, $withOnlinePaymentsTenantEmailConfig: Boolean = false, $withOnlinePaymentsTenantNewsletterProvider: Boolean = false, $withOnlinePaymentsTenantRedirects: Boolean = false, $withOnlinePaymentsTenantOnlinePaymentConfig: Boolean = false, $withOnlinePaymentsTenantRatioConfig: Boolean = false, $withOnlinePaymentsTenantContent: Boolean = false, $withOnlinePaymentsTenantPartnerTenants: Boolean = false, $withTenant: Boolean = false, $withTenantCms: Boolean = false, $withTenantCmsHomepage: Boolean = false, $withTenantCmsCategories: Boolean = false, $withTenantCmsPages: Boolean = false, $withTenantCmsErrorPage404: Boolean = false, $withTenantCmsErrorPage500: Boolean = false, $withTenantCmsConfig: Boolean = false, $withTenantTravelTypes: Boolean = false, $withTenantTravelTypesImage: Boolean = false, $withTenantEmployees: Boolean = false, $withTenantEmployeesImage: Boolean = false, $withTenantEmailConfig: Boolean = false, $withTenantNewsletterProvider: Boolean = false, $withTenantNewsletterProviderConfig: Boolean = false, $withTenantRedirects: Boolean = false, $withTenantRedirectsFromPage: Boolean = false, $withTenantRedirectsFromTravel: Boolean = false, $withTenantRedirectsToPage: Boolean = false, $withTenantRedirectsToTravel: Boolean = false, $withTenantOnlinePaymentConfig: Boolean = false, $withTenantRatioConfig: Boolean = false, $withTenantContent: Boolean = false, $withTenantPartnerTenants: Boolean = false, $withTenantPartnerTenantsTenant: Boolean = false) {
    booking: createBooking(input: $input) {
      id
      referenceNo
      travel @include(if: $withTravel) {
        id
        name
        isBestseller
        startDate
        endDate
        availabilityStatus @include(if: $withTravelAvailabilityStatus) {
          id
          label
          status
          isDefaultStatus
          isDefaultWaitlistFallback
          tenantSettings @include(if: $withTravelAvailabilityStatusTenantSettings) {
            id
            label
            info
            switchToStatusInfo
            submitButtonLabel
          }
        }
        executionStatus
        travelConsultant @include(if: $withTravelTravelConsultant) {
          id
          firstName
          lastName
          jobTitle
          description
          email
          image @include(if: $withTravelTravelConsultantImage) {
            id
            assetId
            publicId
            url
            resourceType
            format
            width
            height
            caption
            title
            description
          }
          phone
        }
        label @include(if: $withTravelLabel) {
          id
          label
        }
        title
        description
        includedServices
        excludedServices
        pricingTable
        priceCalculationInfo
        seoSettings @include(if: $withTravelSeoSettings) {
          id
          urlSlug
          metaTitle
          metaDescription
          ogTitle
          ogDescription
          ogImage @include(if: $withTravelSeoSettingsOgImage) {
            id
            assetId
            publicId
            url
            resourceType
            format
            width
            height
            caption
            title
            description
          }
        }
        tenantSettings @include(if: $withTravelTenantSettings) {
          id
          tenant @include(if: $withTravelTenantSettingsTenant) {
            id
            name
            slug
            domain
            externalReference
          }
          onlineStatus
          redirectToBooking
          useTiming
          startDate
          endDate
          travelTypes @include(if: $withTravelTenantSettingsTravelTypes) {
            id
            name
            description
          }
        }
        highlights @include(if: $withTravelHighlights) {
          id
          text
        }
        partners @include(if: $withTravelPartners) {
          id
          name
          url
          logo @include(if: $withTravelPartnersLogo) {
            id
            assetId
            publicId
            url
            resourceType
            format
            width
            height
            caption
            title
            description
          }
          logoWidth
          gtcPdf @include(if: $withTravelPartnersGtcPdf) {
            id
            assetId
            publicId
            url
            resourceType
            format
            width
            height
            caption
            title
            description
          }
        }
        travelGuides @include(if: $withTravelTravelGuides) {
          id
          firstName
          lastName
          description
          image @include(if: $withTravelTravelGuidesImage) {
            id
            assetId
            publicId
            url
            resourceType
            format
            width
            height
            caption
            title
            description
          }
        }
        teams @include(if: $withTravelTeams) {
          id
          name
          members @include(if: $withTravelTeamsMembers) {
            id
            firstName
            lastName
            description
          }
        }
        accommodationAssignments @include(if: $withTravelAccommodationAssignments) {
          id
          accommodation @include(if: $withTravelAccommodationAssignmentsAccommodation) {
            id
            label
            name
            stars
            description
          }
          roomTypes @include(if: $withTravelAccommodationAssignmentsRoomTypes) {
            id
            name
            description
          }
          useCustomRoomTypeSelection
        }
        accommodations @include(if: $withTravelAccommodations) {
          id
          label
          name
          stars
          description
          roomTypes @include(if: $withTravelAccommodationsRoomTypes) {
            id
            name
            description
          }
          availableAddons @include(if: $withTravelAccommodationsAvailableAddons) {
            id
            name
            description
          }
          gallery @include(if: $withTravelAccommodationsGallery) {
            id
          }
        }
        destinations @include(if: $withTravelDestinations) {
          id
          name
          entryRequirements
          medicalInformation
          language
          timeShift
          climate
          currency
        }
        testimonials @include(if: $withTravelTestimonials) {
          id
          contentBlock @include(if: $withTravelTestimonialsContentBlock) {
            id
            title
            text
            imagePosition
          }
        }
        mainImage @include(if: $withTravelMainImage) {
          id
          assetId
          publicId
          url
          resourceType
          format
          width
          height
          caption
          title
          description
        }
        mainVideo @include(if: $withTravelMainVideo) {
          id
          assetId
          publicId
          url
          resourceType
          format
          width
          height
          caption
          title
          description
        }
        gallery @include(if: $withTravelGallery) {
          id
          images @include(if: $withTravelGalleryImages) {
            id
            assetId
            publicId
            url
            resourceType
            format
            width
            height
            caption
            title
            description
          }
        }
        travelPdf @include(if: $withTravelTravelPdf) {
          id
          assetId
          publicId
          url
          resourceType
          format
          width
          height
          caption
          title
          description
        }
        travelExtensions @include(if: $withTravelTravelExtensions) {
          id
          duration
          name
          description
          highlights @include(if: $withTravelTravelExtensionsHighlights) {
            id
            text
          }
          image @include(if: $withTravelTravelExtensionsImage) {
            id
            assetId
            publicId
            url
            resourceType
            format
            width
            height
            caption
            title
            description
          }
        }
        programType
        itinerary @include(if: $withTravelItinerary) {
          id
          items @include(if: $withTravelItineraryItems) {
            id
            duration
            title
            text
          }
        }
        programText
        pricing @include(if: $withTravelPricing) {
          id
          ageGroupSettings @include(if: $withTravelPricingAgeGroupSettings) {
            id
            freeUntilAge
          }
          isTravelDocumentationAvailable
          customDataConfig @include(if: $withTravelPricingCustomDataConfig) {
            id
            useTravellerForm
            useBookingForm
          }
          travels @include(if: $withTravelPricingTravels) {
            id
            catalogCode
            travelCode
            destination
            name
            transportType
            transportTypeLabel
            importDateTime
            importStatus
          }
          webhookConfig @include(if: $withTravelPricingWebhookConfig) {
            id
            enabled
            url
          }
          branding @include(if: $withTravelPricingBranding) {
            id
            logoWidth
          }
          bargainSettings @include(if: $withTravelPricingBargainSettings) {
            id
            active
            untilDaysBeforeStart
          }
          esimSettings @include(if: $withTravelPricingEsimSettings) {
            id
            enabled
          }
          passportConfig @include(if: $withTravelPricingPassportConfig) {
            id
            passportOnly
          }
          tourOperator @include(if: $withTravelPricingTourOperator) {
            id
            name
            url
            logoWidth
          }
        }
        minPrice
        minPriceManualOverride
        currency
      }
      pricingTravel @include(if: $withPricingTravel) {
        id
        ratioCatalogBundle @include(if: $withPricingTravelRatioCatalogBundle) {
          id
          catalogCode
          travelCode
          json
        }
        catalogCode
        travelCode
        destination
        name
        transportType
        transportTypeLabel
        dates @include(if: $withPricingTravelDates) {
          id
          dateNo
          startDate
          endDate
          availabilityStatus @include(if: $withPricingTravelDatesAvailabilityStatus) {
            id
            label
            status
            isDefaultStatus
            isDefaultWaitlistFallback
          }
          includesExtension
          extensionBaseDate @include(if: $withPricingTravelDatesExtensionBaseDate) {
            id
            dateNo
            startDate
            endDate
            includesExtension
            json
          }
          extension @include(if: $withPricingTravelDatesExtension) {
            id
            label
            info
          }
          packageSettings @include(if: $withPricingTravelDatesPackageSettings) {
            id
            ratioPackageNo
            price
            availabilityStatus
          }
          json
          extensions @include(if: $withPricingTravelDatesExtensions) {
            id
            label
            info
          }
        }
        accommodations @include(if: $withPricingTravelAccommodations) {
          id
          ratioPackageNo
          name
          label
          info
          isFamilyPackageAccommodation
          isBabyPackage
          capacitySettings @include(if: $withPricingTravelAccommodationsCapacitySettings) {
            id
            totalCapacity
            rangesAllowed
            partialOccupancyAllowed
          }
          addons @include(if: $withPricingTravelAccommodationsAddons) {
            id
            ratioServiceNo
            name
            label
            info
          }
        }
        extensionAccommodations @include(if: $withPricingTravelExtensionAccommodations) {
          id
          ratioPackageNo
          name
          label
          info
          extensionAccommodationServiceNo
        }
        familyPackages @include(if: $withPricingTravelFamilyPackages) {
          id
          ratioServiceNo
          accommodation @include(if: $withPricingTravelFamilyPackagesAccommodation) {
            id
            ratioPackageNo
            name
            label
            info
            isFamilyPackageAccommodation
            isBabyPackage
          }
          name
          label
          info
          capacitySettings @include(if: $withPricingTravelFamilyPackagesCapacitySettings) {
            id
            totalCapacity
            rangesAllowed
            partialOccupancyAllowed
          }
          addons @include(if: $withPricingTravelFamilyPackagesAddons) {
            id
            ratioServiceNo
            name
            label
            info
          }
        }
        personalAddons @include(if: $withPricingTravelPersonalAddons) {
          id
          ratioServiceNo
          name
          label
          info
          allowedAgeGroups @include(if: $withPricingTravelPersonalAddonsAllowedAgeGroups) {
            id
            name
            type
            icon
            minAge
            maxAge
          }
          calculationSettings @include(if: $withPricingTravelPersonalAddonsCalculationSettings) {
            id
            type
            considerHotelNights
          }
          mandatorySettings @include(if: $withPricingTravelPersonalAddonsMandatorySettings) {
            id
            isMandatory
            useRules
          }
        }
        accommodationAddons @include(if: $withPricingTravelAccommodationAddons) {
          id
          ratioServiceNo
          name
          label
          info
          calculationSettings @include(if: $withPricingTravelAccommodationAddonsCalculationSettings) {
            id
            type
            considerHotelNights
          }
          mandatorySettings @include(if: $withPricingTravelAccommodationAddonsMandatorySettings) {
            id
            isMandatory
            useRules
          }
        }
        bookingAddons @include(if: $withPricingTravelBookingAddons) {
          id
          ratioServiceNo
          name
          label
          info
          calculationSettings @include(if: $withPricingTravelBookingAddonsCalculationSettings) {
            id
            type
            considerHotelNights
          }
          mandatorySettings @include(if: $withPricingTravelBookingAddonsMandatorySettings) {
            id
            isMandatory
            useRules
          }
        }
        collectiveAddons @include(if: $withPricingTravelCollectiveAddons) {
          id
          label
          info
          ageGroupServices @include(if: $withPricingTravelCollectiveAddonsAgeGroupServices) {
            id
            ratioServiceNo
          }
          calculationSettings @include(if: $withPricingTravelCollectiveAddonsCalculationSettings) {
            id
            type
            considerHotelNights
          }
          mandatorySettings @include(if: $withPricingTravelCollectiveAddonsMandatorySettings) {
            id
            isMandatory
            useRules
          }
        }
        extensions @include(if: $withPricingTravelExtensions) {
          id
          label
          info
          travelExtension @include(if: $withPricingTravelExtensionsTravelExtension) {
            id
            duration
            name
            description
          }
          accommodationMapItems @include(if: $withPricingTravelExtensionsAccommodationMapItems) {
            id
          }
        }
        personalDiscounts @include(if: $withPricingTravelPersonalDiscounts) {
          id
          ratioServiceNo
          name
          label
          info
          mandatorySettings @include(if: $withPricingTravelPersonalDiscountsMandatorySettings) {
            id
            isMandatory
            useRules
          }
        }
        importDateTime
        importStatus
      }
      travelDate @include(if: $withTravelDate) {
        id
        dateNo
        startDate
        endDate
        availabilityStatus @include(if: $withTravelDateAvailabilityStatus) {
          id
          label
          status
          isDefaultStatus
          isDefaultWaitlistFallback
          tenantSettings @include(if: $withTravelDateAvailabilityStatusTenantSettings) {
            id
            label
            info
            switchToStatusInfo
            submitButtonLabel
          }
        }
        includesExtension
        extensionBaseDate @include(if: $withTravelDateExtensionBaseDate) {
          id
          dateNo
          startDate
          endDate
          availabilityStatus @include(if: $withTravelDateExtensionBaseDateAvailabilityStatus) {
            id
            label
            status
            isDefaultStatus
            isDefaultWaitlistFallback
          }
          includesExtension
          extensionBaseDate @include(if: $withTravelDateExtensionBaseDateExtensionBaseDate) {
            id
            dateNo
            startDate
            endDate
            includesExtension
            json
          }
          extension @include(if: $withTravelDateExtensionBaseDateExtension) {
            id
            label
            info
          }
          packageSettings @include(if: $withTravelDateExtensionBaseDatePackageSettings) {
            id
            ratioPackageNo
            price
            availabilityStatus
          }
          json
          extensions @include(if: $withTravelDateExtensionBaseDateExtensions) {
            id
            label
            info
          }
        }
        extension @include(if: $withTravelDateExtension) {
          id
          label
          info
          travelExtension @include(if: $withTravelDateExtensionTravelExtension) {
            id
            duration
            name
            description
          }
          accommodationMapItems @include(if: $withTravelDateExtensionAccommodationMapItems) {
            id
          }
        }
        packageSettings @include(if: $withTravelDatePackageSettings) {
          id
          ratioPackageNo
          price
          availabilityStatus
        }
        json
        extensions @include(if: $withTravelDateExtensions) {
          id
          label
          info
          travelExtension @include(if: $withTravelDateExtensionsTravelExtension) {
            id
            duration
            name
            description
          }
          accommodationMapItems @include(if: $withTravelDateExtensionsAccommodationMapItems) {
            id
          }
        }
      }
      travellers @include(if: $withTravellers) {
        id
        salutation
        firstName
        lastName
        birthday
        nationality
        email
        phone
        address
        addressNumber
        addressAddition
        zip
        city
        country
        ageGroup @include(if: $withTravellersAgeGroup) {
          id
          name
          type
          icon
          minAge
          maxAge
        }
        accommodation @include(if: $withTravellersAccommodation) {
          id
          ratioPackageNo
          name
          label
          info
          isFamilyPackageAccommodation
          isBabyPackage
          capacitySettings @include(if: $withTravellersAccommodationCapacitySettings) {
            id
            totalCapacity
            rangesAllowed
            partialOccupancyAllowed
          }
          addons @include(if: $withTravellersAccommodationAddons) {
            id
            ratioServiceNo
            name
            label
            info
          }
        }
        familyPackage @include(if: $withTravellersFamilyPackage) {
          id
          ratioServiceNo
          accommodation @include(if: $withTravellersFamilyPackageAccommodation) {
            id
            ratioPackageNo
            name
            label
            info
            isFamilyPackageAccommodation
            isBabyPackage
          }
          name
          label
          info
          capacitySettings @include(if: $withTravellersFamilyPackageCapacitySettings) {
            id
            totalCapacity
            rangesAllowed
            partialOccupancyAllowed
          }
          addons @include(if: $withTravellersFamilyPackageAddons) {
            id
            ratioServiceNo
            name
            label
            info
          }
        }
        accommodationAddons @include(if: $withTravellersAccommodationAddons) {
          id
          ratioServiceNo
          name
          label
          info
          calculationSettings @include(if: $withTravellersAccommodationAddonsCalculationSettings) {
            id
            type
            considerHotelNights
          }
          mandatorySettings @include(if: $withTravellersAccommodationAddonsMandatorySettings) {
            id
            isMandatory
            useRules
          }
        }
        personalAddons @include(if: $withTravellersPersonalAddons) {
          id
          ratioServiceNo
          name
          label
          info
          allowedAgeGroups @include(if: $withTravellersPersonalAddonsAllowedAgeGroups) {
            id
            name
            type
            icon
            minAge
            maxAge
          }
          calculationSettings @include(if: $withTravellersPersonalAddonsCalculationSettings) {
            id
            type
            considerHotelNights
          }
          mandatorySettings @include(if: $withTravellersPersonalAddonsMandatorySettings) {
            id
            isMandatory
            useRules
          }
        }
        bookingAddons @include(if: $withTravellersBookingAddons) {
          id
          ratioServiceNo
          name
          label
          info
          calculationSettings @include(if: $withTravellersBookingAddonsCalculationSettings) {
            id
            type
            considerHotelNights
          }
          mandatorySettings @include(if: $withTravellersBookingAddonsMandatorySettings) {
            id
            isMandatory
            useRules
          }
        }
        extensions @include(if: $withTravellersExtensions) {
          id
          label
          info
          travelExtension @include(if: $withTravellersExtensionsTravelExtension) {
            id
            duration
            name
            description
          }
          accommodationMapItems @include(if: $withTravellersExtensionsAccommodationMapItems) {
            id
          }
        }
        passportData @include(if: $withTravellersPassportData) {
          id
          type
          number
          birthPlace
          issuePlace
          issueDate
          validUntil
        }
      }
      travellerRemarks
      travellerDataCorrectnessConfirmation
      localState
      backofficePayload
      backofficeResponse
      transmissionStatus
      webhookStatus
      webhookResponse
      webhookDuration
      onlinePayments @include(if: $withOnlinePayments) {
        id
        transactionId
        tenant @include(if: $withOnlinePaymentsTenant) {
          id
          name
          slug
          domain
          externalReference
          cms @include(if: $withOnlinePaymentsTenantCms) {
            id
          }
          travelTypes @include(if: $withOnlinePaymentsTenantTravelTypes) {
            id
            name
            description
          }
          employees @include(if: $withOnlinePaymentsTenantEmployees) {
            id
            firstName
            lastName
            jobTitle
            description
            email
            phone
          }
          emailConfig @include(if: $withOnlinePaymentsTenantEmailConfig) {
            id
            defaultInternalRecipientEmail
            internalBookingRecipientEmails
            bookingConfirmationTemplateId
            bookingConfirmationInternalTemplateId
            bookingRequestConfirmationTemplateId
            bookingWaitlistConfirmationTemplateId
            bookingWaitlistContingentCheckConfirmationTemplateId
            bookingCustomRequestTemplateId
            bookingPassportDataReminderTemplateId
            contactFormTemplateId
            esimInstallationInfoTemplateId
          }
          newsletterProvider @include(if: $withOnlinePaymentsTenantNewsletterProvider) {
            id
            provider
          }
          redirects @include(if: $withOnlinePaymentsTenantRedirects) {
            id
            fromType
            fromUrl
            toType
            toUrl
          }
          onlinePaymentConfig @include(if: $withOnlinePaymentsTenantOnlinePaymentConfig) {
            id
            enabled
            ratioFibuAccountNo
            infoText
            datatransThemeConfig
          }
          ratioConfig @include(if: $withOnlinePaymentsTenantRatioConfig) {
            id
            adressgruppe
          }
          content @include(if: $withOnlinePaymentsTenantContent) {
            id
            bookingInsuranceInfo
          }
          partnerTenants @include(if: $withOnlinePaymentsTenantPartnerTenants) {
            id
            filterCrossLinking
          }
        }
        transactionStatus
        submittedToBackoffice
        statusPayload
      }
      confirmationEmailSent
      tenant @include(if: $withTenant) {
        id
        name
        slug
        domain
        externalReference
        cms @include(if: $withTenantCms) {
          id
          homepage @include(if: $withTenantCmsHomepage) {
            id
            name
            onlineStatus
          }
          categories @include(if: $withTenantCmsCategories) {
            id
            name
          }
          pages @include(if: $withTenantCmsPages) {
            id
            name
            onlineStatus
          }
          errorPage404 @include(if: $withTenantCmsErrorPage404) {
            id
            name
            onlineStatus
          }
          errorPage500 @include(if: $withTenantCmsErrorPage500) {
            id
            name
            onlineStatus
          }
          config @include(if: $withTenantCmsConfig) {
            id
          }
        }
        travelTypes @include(if: $withTenantTravelTypes) {
          id
          name
          description
          image @include(if: $withTenantTravelTypesImage) {
            id
            assetId
            publicId
            url
            resourceType
            format
            width
            height
            caption
            title
            description
          }
        }
        employees @include(if: $withTenantEmployees) {
          id
          firstName
          lastName
          jobTitle
          description
          email
          image @include(if: $withTenantEmployeesImage) {
            id
            assetId
            publicId
            url
            resourceType
            format
            width
            height
            caption
            title
            description
          }
          phone
        }
        emailConfig @include(if: $withTenantEmailConfig) {
          id
          defaultInternalRecipientEmail
          internalBookingRecipientEmails
          bookingConfirmationTemplateId
          bookingConfirmationInternalTemplateId
          bookingRequestConfirmationTemplateId
          bookingWaitlistConfirmationTemplateId
          bookingWaitlistContingentCheckConfirmationTemplateId
          bookingCustomRequestTemplateId
          bookingPassportDataReminderTemplateId
          contactFormTemplateId
          esimInstallationInfoTemplateId
        }
        newsletterProvider @include(if: $withTenantNewsletterProvider) {
          id
          provider
          config @include(if: $withTenantNewsletterProviderConfig) {
            __typename
            ... on MailchimpConfig {
              id
              apiKey
              serverPrefix
              listId

            }
          }
        }
        redirects @include(if: $withTenantRedirects) {
          id
          fromType
          fromUrl
          fromPage @include(if: $withTenantRedirectsFromPage) {
            id
            name
            onlineStatus
          }
          fromTravel @include(if: $withTenantRedirectsFromTravel) {
            id
            name
            isBestseller
            startDate
            endDate
            executionStatus
            title
            description
            includedServices
            excludedServices
            pricingTable
            priceCalculationInfo
            programType
            programText
            minPrice
            minPriceManualOverride
            currency
          }
          toType
          toUrl
          toPage @include(if: $withTenantRedirectsToPage) {
            id
            name
            onlineStatus
          }
          toTravel @include(if: $withTenantRedirectsToTravel) {
            id
            name
            isBestseller
            startDate
            endDate
            executionStatus
            title
            description
            includedServices
            excludedServices
            pricingTable
            priceCalculationInfo
            programType
            programText
            minPrice
            minPriceManualOverride
            currency
          }
        }
        onlinePaymentConfig @include(if: $withTenantOnlinePaymentConfig) {
          id
          enabled
          ratioFibuAccountNo
          infoText
          datatransThemeConfig
        }
        ratioConfig @include(if: $withTenantRatioConfig) {
          id
          adressgruppe
        }
        content @include(if: $withTenantContent) {
          id
          bookingInsuranceInfo
        }
        partnerTenants @include(if: $withTenantPartnerTenants) {
          id
          tenant @include(if: $withTenantPartnerTenantsTenant) {
            id
            name
            slug
            domain
            externalReference
          }
          filterCrossLinking
        }
      }
      isPassportDataRequired
      passportDataReminderEmailSent
      passportDataReceived
    }
  }`

// language=GraphQL
export const UPDATE_BOOKING_MUTATION = `
  mutation Mutation($input: UpdateBookingInput, $withTravel: Boolean = false, $withTravelAvailabilityStatus: Boolean = false, $withTravelAvailabilityStatusTenantSettings: Boolean = false, $withTravelTravelConsultant: Boolean = false, $withTravelTravelConsultantImage: Boolean = false, $withTravelLabel: Boolean = false, $withTravelSeoSettings: Boolean = false, $withTravelSeoSettingsOgImage: Boolean = false, $withTravelTenantSettings: Boolean = false, $withTravelTenantSettingsTenant: Boolean = false, $withTravelTenantSettingsTravelTypes: Boolean = false, $withTravelHighlights: Boolean = false, $withTravelPartners: Boolean = false, $withTravelPartnersLogo: Boolean = false, $withTravelPartnersGtcPdf: Boolean = false, $withTravelTravelGuides: Boolean = false, $withTravelTravelGuidesImage: Boolean = false, $withTravelTeams: Boolean = false, $withTravelTeamsMembers: Boolean = false, $withTravelAccommodationAssignments: Boolean = false, $withTravelAccommodationAssignmentsAccommodation: Boolean = false, $withTravelAccommodationAssignmentsRoomTypes: Boolean = false, $withTravelAccommodations: Boolean = false, $withTravelAccommodationsRoomTypes: Boolean = false, $withTravelAccommodationsAvailableAddons: Boolean = false, $withTravelAccommodationsGallery: Boolean = false, $withTravelDestinations: Boolean = false, $withTravelTestimonials: Boolean = false, $withTravelTestimonialsContentBlock: Boolean = false, $withTravelMainImage: Boolean = false, $withTravelMainVideo: Boolean = false, $withTravelGallery: Boolean = false, $withTravelGalleryImages: Boolean = false, $withTravelTravelPdf: Boolean = false, $withTravelTravelExtensions: Boolean = false, $withTravelTravelExtensionsHighlights: Boolean = false, $withTravelTravelExtensionsImage: Boolean = false, $withTravelItinerary: Boolean = false, $withTravelItineraryItems: Boolean = false, $withTravelPricing: Boolean = false, $withTravelPricingAgeGroupSettings: Boolean = false, $withTravelPricingCustomDataConfig: Boolean = false, $withTravelPricingTravels: Boolean = false, $withTravelPricingWebhookConfig: Boolean = false, $withTravelPricingBranding: Boolean = false, $withTravelPricingBargainSettings: Boolean = false, $withTravelPricingEsimSettings: Boolean = false, $withTravelPricingPassportConfig: Boolean = false, $withTravelPricingTourOperator: Boolean = false, $withPricingTravel: Boolean = false, $withPricingTravelRatioCatalogBundle: Boolean = false, $withPricingTravelDates: Boolean = false, $withPricingTravelDatesAvailabilityStatus: Boolean = false, $withPricingTravelDatesExtensionBaseDate: Boolean = false, $withPricingTravelDatesExtension: Boolean = false, $withPricingTravelDatesPackageSettings: Boolean = false, $withPricingTravelDatesExtensions: Boolean = false, $withPricingTravelAccommodations: Boolean = false, $withPricingTravelAccommodationsCapacitySettings: Boolean = false, $withPricingTravelAccommodationsAddons: Boolean = false, $withPricingTravelExtensionAccommodations: Boolean = false, $withPricingTravelFamilyPackages: Boolean = false, $withPricingTravelFamilyPackagesAccommodation: Boolean = false, $withPricingTravelFamilyPackagesCapacitySettings: Boolean = false, $withPricingTravelFamilyPackagesAddons: Boolean = false, $withPricingTravelPersonalAddons: Boolean = false, $withPricingTravelPersonalAddonsAllowedAgeGroups: Boolean = false, $withPricingTravelPersonalAddonsCalculationSettings: Boolean = false, $withPricingTravelPersonalAddonsMandatorySettings: Boolean = false, $withPricingTravelAccommodationAddons: Boolean = false, $withPricingTravelAccommodationAddonsCalculationSettings: Boolean = false, $withPricingTravelAccommodationAddonsMandatorySettings: Boolean = false, $withPricingTravelBookingAddons: Boolean = false, $withPricingTravelBookingAddonsCalculationSettings: Boolean = false, $withPricingTravelBookingAddonsMandatorySettings: Boolean = false, $withPricingTravelCollectiveAddons: Boolean = false, $withPricingTravelCollectiveAddonsAgeGroupServices: Boolean = false, $withPricingTravelCollectiveAddonsCalculationSettings: Boolean = false, $withPricingTravelCollectiveAddonsMandatorySettings: Boolean = false, $withPricingTravelExtensions: Boolean = false, $withPricingTravelExtensionsTravelExtension: Boolean = false, $withPricingTravelExtensionsAccommodationMapItems: Boolean = false, $withPricingTravelPersonalDiscounts: Boolean = false, $withPricingTravelPersonalDiscountsMandatorySettings: Boolean = false, $withTravelDate: Boolean = false, $withTravelDateAvailabilityStatus: Boolean = false, $withTravelDateAvailabilityStatusTenantSettings: Boolean = false, $withTravelDateExtensionBaseDate: Boolean = false, $withTravelDateExtensionBaseDateAvailabilityStatus: Boolean = false, $withTravelDateExtensionBaseDateExtensionBaseDate: Boolean = false, $withTravelDateExtensionBaseDateExtension: Boolean = false, $withTravelDateExtensionBaseDatePackageSettings: Boolean = false, $withTravelDateExtensionBaseDateExtensions: Boolean = false, $withTravelDateExtension: Boolean = false, $withTravelDateExtensionTravelExtension: Boolean = false, $withTravelDateExtensionAccommodationMapItems: Boolean = false, $withTravelDatePackageSettings: Boolean = false, $withTravelDateExtensions: Boolean = false, $withTravelDateExtensionsTravelExtension: Boolean = false, $withTravelDateExtensionsAccommodationMapItems: Boolean = false, $withTravellers: Boolean = false, $withTravellersAgeGroup: Boolean = false, $withTravellersAccommodation: Boolean = false, $withTravellersAccommodationCapacitySettings: Boolean = false, $withTravellersAccommodationAddons: Boolean = false, $withTravellersFamilyPackage: Boolean = false, $withTravellersFamilyPackageAccommodation: Boolean = false, $withTravellersFamilyPackageCapacitySettings: Boolean = false, $withTravellersFamilyPackageAddons: Boolean = false, $withTravellersAccommodationAddons: Boolean = false, $withTravellersAccommodationAddonsCalculationSettings: Boolean = false, $withTravellersAccommodationAddonsMandatorySettings: Boolean = false, $withTravellersPersonalAddons: Boolean = false, $withTravellersPersonalAddonsAllowedAgeGroups: Boolean = false, $withTravellersPersonalAddonsCalculationSettings: Boolean = false, $withTravellersPersonalAddonsMandatorySettings: Boolean = false, $withTravellersBookingAddons: Boolean = false, $withTravellersBookingAddonsCalculationSettings: Boolean = false, $withTravellersBookingAddonsMandatorySettings: Boolean = false, $withTravellersExtensions: Boolean = false, $withTravellersExtensionsTravelExtension: Boolean = false, $withTravellersExtensionsAccommodationMapItems: Boolean = false, $withTravellersPassportData: Boolean = false, $withOnlinePayments: Boolean = false, $withOnlinePaymentsTenant: Boolean = false, $withOnlinePaymentsTenantCms: Boolean = false, $withOnlinePaymentsTenantTravelTypes: Boolean = false, $withOnlinePaymentsTenantEmployees: Boolean = false, $withOnlinePaymentsTenantEmailConfig: Boolean = false, $withOnlinePaymentsTenantNewsletterProvider: Boolean = false, $withOnlinePaymentsTenantRedirects: Boolean = false, $withOnlinePaymentsTenantOnlinePaymentConfig: Boolean = false, $withOnlinePaymentsTenantRatioConfig: Boolean = false, $withOnlinePaymentsTenantContent: Boolean = false, $withOnlinePaymentsTenantPartnerTenants: Boolean = false, $withTenant: Boolean = false, $withTenantCms: Boolean = false, $withTenantCmsHomepage: Boolean = false, $withTenantCmsCategories: Boolean = false, $withTenantCmsPages: Boolean = false, $withTenantCmsErrorPage404: Boolean = false, $withTenantCmsErrorPage500: Boolean = false, $withTenantCmsConfig: Boolean = false, $withTenantTravelTypes: Boolean = false, $withTenantTravelTypesImage: Boolean = false, $withTenantEmployees: Boolean = false, $withTenantEmployeesImage: Boolean = false, $withTenantEmailConfig: Boolean = false, $withTenantNewsletterProvider: Boolean = false, $withTenantNewsletterProviderConfig: Boolean = false, $withTenantRedirects: Boolean = false, $withTenantRedirectsFromPage: Boolean = false, $withTenantRedirectsFromTravel: Boolean = false, $withTenantRedirectsToPage: Boolean = false, $withTenantRedirectsToTravel: Boolean = false, $withTenantOnlinePaymentConfig: Boolean = false, $withTenantRatioConfig: Boolean = false, $withTenantContent: Boolean = false, $withTenantPartnerTenants: Boolean = false, $withTenantPartnerTenantsTenant: Boolean = false) {
    booking: updateBooking(input: $input) {
      id
      referenceNo
      travel @include(if: $withTravel) {
        id
        name
        isBestseller
        startDate
        endDate
        availabilityStatus @include(if: $withTravelAvailabilityStatus) {
          id
          label
          status
          isDefaultStatus
          isDefaultWaitlistFallback
          tenantSettings @include(if: $withTravelAvailabilityStatusTenantSettings) {
            id
            label
            info
            switchToStatusInfo
            submitButtonLabel
          }
        }
        executionStatus
        travelConsultant @include(if: $withTravelTravelConsultant) {
          id
          firstName
          lastName
          jobTitle
          description
          email
          image @include(if: $withTravelTravelConsultantImage) {
            id
            assetId
            publicId
            url
            resourceType
            format
            width
            height
            caption
            title
            description
          }
          phone
        }
        label @include(if: $withTravelLabel) {
          id
          label
        }
        title
        description
        includedServices
        excludedServices
        pricingTable
        priceCalculationInfo
        seoSettings @include(if: $withTravelSeoSettings) {
          id
          urlSlug
          metaTitle
          metaDescription
          ogTitle
          ogDescription
          ogImage @include(if: $withTravelSeoSettingsOgImage) {
            id
            assetId
            publicId
            url
            resourceType
            format
            width
            height
            caption
            title
            description
          }
        }
        tenantSettings @include(if: $withTravelTenantSettings) {
          id
          tenant @include(if: $withTravelTenantSettingsTenant) {
            id
            name
            slug
            domain
            externalReference
          }
          onlineStatus
          redirectToBooking
          useTiming
          startDate
          endDate
          travelTypes @include(if: $withTravelTenantSettingsTravelTypes) {
            id
            name
            description
          }
        }
        highlights @include(if: $withTravelHighlights) {
          id
          text
        }
        partners @include(if: $withTravelPartners) {
          id
          name
          url
          logo @include(if: $withTravelPartnersLogo) {
            id
            assetId
            publicId
            url
            resourceType
            format
            width
            height
            caption
            title
            description
          }
          logoWidth
          gtcPdf @include(if: $withTravelPartnersGtcPdf) {
            id
            assetId
            publicId
            url
            resourceType
            format
            width
            height
            caption
            title
            description
          }
        }
        travelGuides @include(if: $withTravelTravelGuides) {
          id
          firstName
          lastName
          description
          image @include(if: $withTravelTravelGuidesImage) {
            id
            assetId
            publicId
            url
            resourceType
            format
            width
            height
            caption
            title
            description
          }
        }
        teams @include(if: $withTravelTeams) {
          id
          name
          members @include(if: $withTravelTeamsMembers) {
            id
            firstName
            lastName
            description
          }
        }
        accommodationAssignments @include(if: $withTravelAccommodationAssignments) {
          id
          accommodation @include(if: $withTravelAccommodationAssignmentsAccommodation) {
            id
            label
            name
            stars
            description
          }
          roomTypes @include(if: $withTravelAccommodationAssignmentsRoomTypes) {
            id
            name
            description
          }
          useCustomRoomTypeSelection
        }
        accommodations @include(if: $withTravelAccommodations) {
          id
          label
          name
          stars
          description
          roomTypes @include(if: $withTravelAccommodationsRoomTypes) {
            id
            name
            description
          }
          availableAddons @include(if: $withTravelAccommodationsAvailableAddons) {
            id
            name
            description
          }
          gallery @include(if: $withTravelAccommodationsGallery) {
            id
          }
        }
        destinations @include(if: $withTravelDestinations) {
          id
          name
          entryRequirements
          medicalInformation
          language
          timeShift
          climate
          currency
        }
        testimonials @include(if: $withTravelTestimonials) {
          id
          contentBlock @include(if: $withTravelTestimonialsContentBlock) {
            id
            title
            text
            imagePosition
          }
        }
        mainImage @include(if: $withTravelMainImage) {
          id
          assetId
          publicId
          url
          resourceType
          format
          width
          height
          caption
          title
          description
        }
        mainVideo @include(if: $withTravelMainVideo) {
          id
          assetId
          publicId
          url
          resourceType
          format
          width
          height
          caption
          title
          description
        }
        gallery @include(if: $withTravelGallery) {
          id
          images @include(if: $withTravelGalleryImages) {
            id
            assetId
            publicId
            url
            resourceType
            format
            width
            height
            caption
            title
            description
          }
        }
        travelPdf @include(if: $withTravelTravelPdf) {
          id
          assetId
          publicId
          url
          resourceType
          format
          width
          height
          caption
          title
          description
        }
        travelExtensions @include(if: $withTravelTravelExtensions) {
          id
          duration
          name
          description
          highlights @include(if: $withTravelTravelExtensionsHighlights) {
            id
            text
          }
          image @include(if: $withTravelTravelExtensionsImage) {
            id
            assetId
            publicId
            url
            resourceType
            format
            width
            height
            caption
            title
            description
          }
        }
        programType
        itinerary @include(if: $withTravelItinerary) {
          id
          items @include(if: $withTravelItineraryItems) {
            id
            duration
            title
            text
          }
        }
        programText
        pricing @include(if: $withTravelPricing) {
          id
          ageGroupSettings @include(if: $withTravelPricingAgeGroupSettings) {
            id
            freeUntilAge
          }
          isTravelDocumentationAvailable
          customDataConfig @include(if: $withTravelPricingCustomDataConfig) {
            id
            useTravellerForm
            useBookingForm
          }
          travels @include(if: $withTravelPricingTravels) {
            id
            catalogCode
            travelCode
            destination
            name
            transportType
            transportTypeLabel
            importDateTime
            importStatus
          }
          webhookConfig @include(if: $withTravelPricingWebhookConfig) {
            id
            enabled
            url
          }
          branding @include(if: $withTravelPricingBranding) {
            id
            logoWidth
          }
          bargainSettings @include(if: $withTravelPricingBargainSettings) {
            id
            active
            untilDaysBeforeStart
          }
          esimSettings @include(if: $withTravelPricingEsimSettings) {
            id
            enabled
          }
          passportConfig @include(if: $withTravelPricingPassportConfig) {
            id
            passportOnly
          }
          tourOperator @include(if: $withTravelPricingTourOperator) {
            id
            name
            url
            logoWidth
          }
        }
        minPrice
        minPriceManualOverride
        currency
      }
      pricingTravel @include(if: $withPricingTravel) {
        id
        ratioCatalogBundle @include(if: $withPricingTravelRatioCatalogBundle) {
          id
          catalogCode
          travelCode
          json
        }
        catalogCode
        travelCode
        destination
        name
        transportType
        transportTypeLabel
        dates @include(if: $withPricingTravelDates) {
          id
          dateNo
          startDate
          endDate
          availabilityStatus @include(if: $withPricingTravelDatesAvailabilityStatus) {
            id
            label
            status
            isDefaultStatus
            isDefaultWaitlistFallback
          }
          includesExtension
          extensionBaseDate @include(if: $withPricingTravelDatesExtensionBaseDate) {
            id
            dateNo
            startDate
            endDate
            includesExtension
            json
          }
          extension @include(if: $withPricingTravelDatesExtension) {
            id
            label
            info
          }
          packageSettings @include(if: $withPricingTravelDatesPackageSettings) {
            id
            ratioPackageNo
            price
            availabilityStatus
          }
          json
          extensions @include(if: $withPricingTravelDatesExtensions) {
            id
            label
            info
          }
        }
        accommodations @include(if: $withPricingTravelAccommodations) {
          id
          ratioPackageNo
          name
          label
          info
          isFamilyPackageAccommodation
          isBabyPackage
          capacitySettings @include(if: $withPricingTravelAccommodationsCapacitySettings) {
            id
            totalCapacity
            rangesAllowed
            partialOccupancyAllowed
          }
          addons @include(if: $withPricingTravelAccommodationsAddons) {
            id
            ratioServiceNo
            name
            label
            info
          }
        }
        extensionAccommodations @include(if: $withPricingTravelExtensionAccommodations) {
          id
          ratioPackageNo
          name
          label
          info
          extensionAccommodationServiceNo
        }
        familyPackages @include(if: $withPricingTravelFamilyPackages) {
          id
          ratioServiceNo
          accommodation @include(if: $withPricingTravelFamilyPackagesAccommodation) {
            id
            ratioPackageNo
            name
            label
            info
            isFamilyPackageAccommodation
            isBabyPackage
          }
          name
          label
          info
          capacitySettings @include(if: $withPricingTravelFamilyPackagesCapacitySettings) {
            id
            totalCapacity
            rangesAllowed
            partialOccupancyAllowed
          }
          addons @include(if: $withPricingTravelFamilyPackagesAddons) {
            id
            ratioServiceNo
            name
            label
            info
          }
        }
        personalAddons @include(if: $withPricingTravelPersonalAddons) {
          id
          ratioServiceNo
          name
          label
          info
          allowedAgeGroups @include(if: $withPricingTravelPersonalAddonsAllowedAgeGroups) {
            id
            name
            type
            icon
            minAge
            maxAge
          }
          calculationSettings @include(if: $withPricingTravelPersonalAddonsCalculationSettings) {
            id
            type
            considerHotelNights
          }
          mandatorySettings @include(if: $withPricingTravelPersonalAddonsMandatorySettings) {
            id
            isMandatory
            useRules
          }
        }
        accommodationAddons @include(if: $withPricingTravelAccommodationAddons) {
          id
          ratioServiceNo
          name
          label
          info
          calculationSettings @include(if: $withPricingTravelAccommodationAddonsCalculationSettings) {
            id
            type
            considerHotelNights
          }
          mandatorySettings @include(if: $withPricingTravelAccommodationAddonsMandatorySettings) {
            id
            isMandatory
            useRules
          }
        }
        bookingAddons @include(if: $withPricingTravelBookingAddons) {
          id
          ratioServiceNo
          name
          label
          info
          calculationSettings @include(if: $withPricingTravelBookingAddonsCalculationSettings) {
            id
            type
            considerHotelNights
          }
          mandatorySettings @include(if: $withPricingTravelBookingAddonsMandatorySettings) {
            id
            isMandatory
            useRules
          }
        }
        collectiveAddons @include(if: $withPricingTravelCollectiveAddons) {
          id
          label
          info
          ageGroupServices @include(if: $withPricingTravelCollectiveAddonsAgeGroupServices) {
            id
            ratioServiceNo
          }
          calculationSettings @include(if: $withPricingTravelCollectiveAddonsCalculationSettings) {
            id
            type
            considerHotelNights
          }
          mandatorySettings @include(if: $withPricingTravelCollectiveAddonsMandatorySettings) {
            id
            isMandatory
            useRules
          }
        }
        extensions @include(if: $withPricingTravelExtensions) {
          id
          label
          info
          travelExtension @include(if: $withPricingTravelExtensionsTravelExtension) {
            id
            duration
            name
            description
          }
          accommodationMapItems @include(if: $withPricingTravelExtensionsAccommodationMapItems) {
            id
          }
        }
        personalDiscounts @include(if: $withPricingTravelPersonalDiscounts) {
          id
          ratioServiceNo
          name
          label
          info
          mandatorySettings @include(if: $withPricingTravelPersonalDiscountsMandatorySettings) {
            id
            isMandatory
            useRules
          }
        }
        importDateTime
        importStatus
      }
      travelDate @include(if: $withTravelDate) {
        id
        dateNo
        startDate
        endDate
        availabilityStatus @include(if: $withTravelDateAvailabilityStatus) {
          id
          label
          status
          isDefaultStatus
          isDefaultWaitlistFallback
          tenantSettings @include(if: $withTravelDateAvailabilityStatusTenantSettings) {
            id
            label
            info
            switchToStatusInfo
            submitButtonLabel
          }
        }
        includesExtension
        extensionBaseDate @include(if: $withTravelDateExtensionBaseDate) {
          id
          dateNo
          startDate
          endDate
          availabilityStatus @include(if: $withTravelDateExtensionBaseDateAvailabilityStatus) {
            id
            label
            status
            isDefaultStatus
            isDefaultWaitlistFallback
          }
          includesExtension
          extensionBaseDate @include(if: $withTravelDateExtensionBaseDateExtensionBaseDate) {
            id
            dateNo
            startDate
            endDate
            includesExtension
            json
          }
          extension @include(if: $withTravelDateExtensionBaseDateExtension) {
            id
            label
            info
          }
          packageSettings @include(if: $withTravelDateExtensionBaseDatePackageSettings) {
            id
            ratioPackageNo
            price
            availabilityStatus
          }
          json
          extensions @include(if: $withTravelDateExtensionBaseDateExtensions) {
            id
            label
            info
          }
        }
        extension @include(if: $withTravelDateExtension) {
          id
          label
          info
          travelExtension @include(if: $withTravelDateExtensionTravelExtension) {
            id
            duration
            name
            description
          }
          accommodationMapItems @include(if: $withTravelDateExtensionAccommodationMapItems) {
            id
          }
        }
        packageSettings @include(if: $withTravelDatePackageSettings) {
          id
          ratioPackageNo
          price
          availabilityStatus
        }
        json
        extensions @include(if: $withTravelDateExtensions) {
          id
          label
          info
          travelExtension @include(if: $withTravelDateExtensionsTravelExtension) {
            id
            duration
            name
            description
          }
          accommodationMapItems @include(if: $withTravelDateExtensionsAccommodationMapItems) {
            id
          }
        }
      }
      travellers @include(if: $withTravellers) {
        id
        salutation
        firstName
        lastName
        birthday
        nationality
        email
        phone
        address
        addressNumber
        addressAddition
        zip
        city
        country
        ageGroup @include(if: $withTravellersAgeGroup) {
          id
          name
          type
          icon
          minAge
          maxAge
        }
        accommodation @include(if: $withTravellersAccommodation) {
          id
          ratioPackageNo
          name
          label
          info
          isFamilyPackageAccommodation
          isBabyPackage
          capacitySettings @include(if: $withTravellersAccommodationCapacitySettings) {
            id
            totalCapacity
            rangesAllowed
            partialOccupancyAllowed
          }
          addons @include(if: $withTravellersAccommodationAddons) {
            id
            ratioServiceNo
            name
            label
            info
          }
        }
        familyPackage @include(if: $withTravellersFamilyPackage) {
          id
          ratioServiceNo
          accommodation @include(if: $withTravellersFamilyPackageAccommodation) {
            id
            ratioPackageNo
            name
            label
            info
            isFamilyPackageAccommodation
            isBabyPackage
          }
          name
          label
          info
          capacitySettings @include(if: $withTravellersFamilyPackageCapacitySettings) {
            id
            totalCapacity
            rangesAllowed
            partialOccupancyAllowed
          }
          addons @include(if: $withTravellersFamilyPackageAddons) {
            id
            ratioServiceNo
            name
            label
            info
          }
        }
        accommodationAddons @include(if: $withTravellersAccommodationAddons) {
          id
          ratioServiceNo
          name
          label
          info
          calculationSettings @include(if: $withTravellersAccommodationAddonsCalculationSettings) {
            id
            type
            considerHotelNights
          }
          mandatorySettings @include(if: $withTravellersAccommodationAddonsMandatorySettings) {
            id
            isMandatory
            useRules
          }
        }
        personalAddons @include(if: $withTravellersPersonalAddons) {
          id
          ratioServiceNo
          name
          label
          info
          allowedAgeGroups @include(if: $withTravellersPersonalAddonsAllowedAgeGroups) {
            id
            name
            type
            icon
            minAge
            maxAge
          }
          calculationSettings @include(if: $withTravellersPersonalAddonsCalculationSettings) {
            id
            type
            considerHotelNights
          }
          mandatorySettings @include(if: $withTravellersPersonalAddonsMandatorySettings) {
            id
            isMandatory
            useRules
          }
        }
        bookingAddons @include(if: $withTravellersBookingAddons) {
          id
          ratioServiceNo
          name
          label
          info
          calculationSettings @include(if: $withTravellersBookingAddonsCalculationSettings) {
            id
            type
            considerHotelNights
          }
          mandatorySettings @include(if: $withTravellersBookingAddonsMandatorySettings) {
            id
            isMandatory
            useRules
          }
        }
        extensions @include(if: $withTravellersExtensions) {
          id
          label
          info
          travelExtension @include(if: $withTravellersExtensionsTravelExtension) {
            id
            duration
            name
            description
          }
          accommodationMapItems @include(if: $withTravellersExtensionsAccommodationMapItems) {
            id
          }
        }
        passportData @include(if: $withTravellersPassportData) {
          id
          type
          number
          birthPlace
          issuePlace
          issueDate
          validUntil
        }
      }
      travellerRemarks
      travellerDataCorrectnessConfirmation
      localState
      backofficePayload
      backofficeResponse
      transmissionStatus
      webhookStatus
      webhookResponse
      webhookDuration
      onlinePayments @include(if: $withOnlinePayments) {
        id
        transactionId
        tenant @include(if: $withOnlinePaymentsTenant) {
          id
          name
          slug
          domain
          externalReference
          cms @include(if: $withOnlinePaymentsTenantCms) {
            id
          }
          travelTypes @include(if: $withOnlinePaymentsTenantTravelTypes) {
            id
            name
            description
          }
          employees @include(if: $withOnlinePaymentsTenantEmployees) {
            id
            firstName
            lastName
            jobTitle
            description
            email
            phone
          }
          emailConfig @include(if: $withOnlinePaymentsTenantEmailConfig) {
            id
            defaultInternalRecipientEmail
            internalBookingRecipientEmails
            bookingConfirmationTemplateId
            bookingConfirmationInternalTemplateId
            bookingRequestConfirmationTemplateId
            bookingWaitlistConfirmationTemplateId
            bookingWaitlistContingentCheckConfirmationTemplateId
            bookingCustomRequestTemplateId
            bookingPassportDataReminderTemplateId
            contactFormTemplateId
            esimInstallationInfoTemplateId
          }
          newsletterProvider @include(if: $withOnlinePaymentsTenantNewsletterProvider) {
            id
            provider
          }
          redirects @include(if: $withOnlinePaymentsTenantRedirects) {
            id
            fromType
            fromUrl
            toType
            toUrl
          }
          onlinePaymentConfig @include(if: $withOnlinePaymentsTenantOnlinePaymentConfig) {
            id
            enabled
            ratioFibuAccountNo
            infoText
            datatransThemeConfig
          }
          ratioConfig @include(if: $withOnlinePaymentsTenantRatioConfig) {
            id
            adressgruppe
          }
          content @include(if: $withOnlinePaymentsTenantContent) {
            id
            bookingInsuranceInfo
          }
          partnerTenants @include(if: $withOnlinePaymentsTenantPartnerTenants) {
            id
            filterCrossLinking
          }
        }
        transactionStatus
        submittedToBackoffice
        statusPayload
      }
      confirmationEmailSent
      tenant @include(if: $withTenant) {
        id
        name
        slug
        domain
        externalReference
        cms @include(if: $withTenantCms) {
          id
          homepage @include(if: $withTenantCmsHomepage) {
            id
            name
            onlineStatus
          }
          categories @include(if: $withTenantCmsCategories) {
            id
            name
          }
          pages @include(if: $withTenantCmsPages) {
            id
            name
            onlineStatus
          }
          errorPage404 @include(if: $withTenantCmsErrorPage404) {
            id
            name
            onlineStatus
          }
          errorPage500 @include(if: $withTenantCmsErrorPage500) {
            id
            name
            onlineStatus
          }
          config @include(if: $withTenantCmsConfig) {
            id
          }
        }
        travelTypes @include(if: $withTenantTravelTypes) {
          id
          name
          description
          image @include(if: $withTenantTravelTypesImage) {
            id
            assetId
            publicId
            url
            resourceType
            format
            width
            height
            caption
            title
            description
          }
        }
        employees @include(if: $withTenantEmployees) {
          id
          firstName
          lastName
          jobTitle
          description
          email
          image @include(if: $withTenantEmployeesImage) {
            id
            assetId
            publicId
            url
            resourceType
            format
            width
            height
            caption
            title
            description
          }
          phone
        }
        emailConfig @include(if: $withTenantEmailConfig) {
          id
          defaultInternalRecipientEmail
          internalBookingRecipientEmails
          bookingConfirmationTemplateId
          bookingConfirmationInternalTemplateId
          bookingRequestConfirmationTemplateId
          bookingWaitlistConfirmationTemplateId
          bookingWaitlistContingentCheckConfirmationTemplateId
          bookingCustomRequestTemplateId
          bookingPassportDataReminderTemplateId
          contactFormTemplateId
          esimInstallationInfoTemplateId
        }
        newsletterProvider @include(if: $withTenantNewsletterProvider) {
          id
          provider
          config @include(if: $withTenantNewsletterProviderConfig) {
            __typename
            ... on MailchimpConfig {
              id
              apiKey
              serverPrefix
              listId

            }
          }
        }
        redirects @include(if: $withTenantRedirects) {
          id
          fromType
          fromUrl
          fromPage @include(if: $withTenantRedirectsFromPage) {
            id
            name
            onlineStatus
          }
          fromTravel @include(if: $withTenantRedirectsFromTravel) {
            id
            name
            isBestseller
            startDate
            endDate
            executionStatus
            title
            description
            includedServices
            excludedServices
            pricingTable
            priceCalculationInfo
            programType
            programText
            minPrice
            minPriceManualOverride
            currency
          }
          toType
          toUrl
          toPage @include(if: $withTenantRedirectsToPage) {
            id
            name
            onlineStatus
          }
          toTravel @include(if: $withTenantRedirectsToTravel) {
            id
            name
            isBestseller
            startDate
            endDate
            executionStatus
            title
            description
            includedServices
            excludedServices
            pricingTable
            priceCalculationInfo
            programType
            programText
            minPrice
            minPriceManualOverride
            currency
          }
        }
        onlinePaymentConfig @include(if: $withTenantOnlinePaymentConfig) {
          id
          enabled
          ratioFibuAccountNo
          infoText
          datatransThemeConfig
        }
        ratioConfig @include(if: $withTenantRatioConfig) {
          id
          adressgruppe
        }
        content @include(if: $withTenantContent) {
          id
          bookingInsuranceInfo
        }
        partnerTenants @include(if: $withTenantPartnerTenants) {
          id
          tenant @include(if: $withTenantPartnerTenantsTenant) {
            id
            name
            slug
            domain
            externalReference
          }
          filterCrossLinking
        }
      }
      isPassportDataRequired
      passportDataReminderEmailSent
      passportDataReceived
    }
  }`

// language=GraphQL
export const DELETE_BOOKING_MUTATION = `
  mutation Mutation($input: DeleteBookingInput) {
    deleteBooking(input: $input) {
      success
    }
  }`

// language=GraphQL
export const FORCE_DELETE_BOOKING_MUTATION = `
  mutation Mutation($input: DeleteBookingInput) {
    forceDeleteBooking(input: $input) {
      success
    }
  }`

// language=GraphQL
export const ADD_BOOKING_TRAVELLERS_MUTATION = `
  mutation Mutation($input: addBookingTravellersInput) {
    addBookingTravellers(input: $input) {
      id
      travellerIds
    }
  }`

// language=GraphQL
export const REMOVE_BOOKING_TRAVELLERS_MUTATION = `
  mutation Mutation($input: removeBookingTravellersInput) {
    removeBookingTravellers(input: $input) {
      id
      travellerIds
    }
  }`

// language=GraphQL
export const CREATE_BOOKING_TRAVELLERS_MUTATION = `
  mutation Mutation($input: createBookingTravellersInput) {
    createBookingTravellers(input: $input) {
      id
      travellerIds
    }
  }`

// language=GraphQL
export const DELETE_BOOKING_TRAVELLERS_MUTATION = `
  mutation Mutation($input: deleteBookingTravellersInput) {
    deleteBookingTravellers(input: $input) {
      id
      travellerIds
    }
  }`

// language=GraphQL
export const UPDATE_BOOKING_TRAVELLERS_ORDER_MUTATION = `
  mutation Mutation($input: updateBookingTravellersOrderInput) {
    updateBookingTravellersOrder(input: $input) {
      id
      travellerIds
    }
  }`

// language=GraphQL
export const ADD_BOOKING_ONLINE_PAYMENTS_MUTATION = `
  mutation Mutation($input: addBookingOnlinePaymentsInput) {
    addBookingOnlinePayments(input: $input) {
      id
      onlinePaymentIds
    }
  }`

// language=GraphQL
export const REMOVE_BOOKING_ONLINE_PAYMENTS_MUTATION = `
  mutation Mutation($input: removeBookingOnlinePaymentsInput) {
    removeBookingOnlinePayments(input: $input) {
      id
      onlinePaymentIds
    }
  }`

// language=GraphQL
export const CREATE_BOOKING_ONLINE_PAYMENTS_MUTATION = `
  mutation Mutation($input: createBookingOnlinePaymentsInput) {
    createBookingOnlinePayments(input: $input) {
      id
      onlinePaymentIds
    }
  }`

// language=GraphQL
export const DELETE_BOOKING_ONLINE_PAYMENTS_MUTATION = `
  mutation Mutation($input: deleteBookingOnlinePaymentsInput) {
    deleteBookingOnlinePayments(input: $input) {
      id
      onlinePaymentIds
    }
  }`

// language=GraphQL
export const UPDATE_BOOKING_ONLINE_PAYMENTS_ORDER_MUTATION = `
  mutation Mutation($input: updateBookingOnlinePaymentsOrderInput) {
    updateBookingOnlinePaymentsOrder(input: $input) {
      id
      onlinePaymentIds
    }
  }`
